export const zhTW = {
  // Common
  common: {
    envBannerPrefix: '您正在使用',
    envBannerUnverified: '未驗證的環境',
    versionBadgeTitle: '查看發布說明',
    versionBadgeDev: '開發版',
    ok: '確定',
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    edit: '編輯',
    readOnly: '唯讀',
    change: '更換',
    add: '新增',
    search: '尋找',
    filter: '篩選',
    export: '匯出',
    import: '匯入',
    submit: '提交',
    go: '前往',
    reset: '重設',
    confirm: '確認',
    verify: '驗證',
    close: '關閉',
    clickToViewDetails: '點擊查看詳情',
    done: '完成',
    cancelled: '已取消',
    print: '打印',
    back: '返回',
    goBack: '返回修正',
    dismiss: '關閉',
    dismissed: '已關閉',
    noResults: '找不到結果',
    transfer: '調撥單',
    session: '工單',
    next: '下一步',
    previous: '上一步',
    loading: '載入中...',
    processing: '處理中...',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    info: '資訊',
    yes: '是',
    no: '否',
    select: '選擇',
    selectAll: '全選',
    actions: '操作',
    status: '狀態',
    station: '工作站',
    active: '啟用',
    inactive: '停用',
    enabled: '已啟用',
    disabled: '已停用',
    total: '總計',
    of: '的',
    showing: '顯示',
    logout: '登出',
    settings: '設定',
    location: '地點',
    lot: '批號',
    lotNumber: '批號',
    case: '箱',
    cases: '箱',
    selectLot: '選擇批號...',
    selectProductFirst: '請先選擇產品...',
    transferNumber: '轉移編號',
    saving: '儲存中',
    deleting: '刪除中',
    view: '查看',
    viewAll: '查看全部',
    optional: '可選',
    accept: '接受',
    refresh: '重新整理',
    moreActions: '更多操作',
    linked: '已連結',
    records: '筆記錄',
    all: '全部',
    continue: '繼續',
    filters: '篩選條件',
    exportCsv: '匯出CSV',
    clear: '清除',
    packer: '包裝員',
    startedAt: '開始時間',
    completedAt: '完成時間',
  },

  // Print / Label Preview
  print: {
    previewTitle: '標籤預覽',
    previewDescription: '這是列印後標籤的樣子。',
    copy: '份',
    copies: '份',
    willBePrinted: '將被列印',
  },

  // Status labels for sessions (WCO-2146)
  status: {
    pending: '待處理',
    submitted: '已提交',
    received: '已收到',
    ready: '待開始',
    active: '進行中',
    paused: '已暫停',
    completed: '已完成',
    cancelled: '已取消',
    // Legacy alias for pre-WCO-2146 'planned' rows
    planned: '已收到',
  },

  // OAuth - WayFong 網域認證
  oauth: {
    validating: '正在驗證組織存取權限...',
    redirecting: '正在重新導向至組織登入...',
    error: '組織認證失敗',
    retry: '重試',
    sessionExpired: '您的組織會話已過期。',
    loggedInAs: '已登入為',
    accessDenied: {
      title: '無權存取 HTE 生產系統',
      message: '您的帳號未獲授權使用 HTE 生產系統。請聯絡您的主管申請存取權限。',
      signOut: '登出',
    },
    signedOut: {
      title: '已登出',
      message: '您已登出 HTE 生產系統。',
      signIn: '登入',
    },
  },

  // Authentication
  auth: {
    login: '登入',
    username: '使用者名稱',
    password: '密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼?',
    loginButton: '登入',
    loginError: '使用者名稱或密碼錯誤',
    sessionExpired: '您的會話已過期，請重新登入。',
    unauthorized: '您無權訪問此資源',
    // Password confirmation modal (WCO-2706)
    loggedInAs: '登入身分',
  },

  // Navigation
  nav: {
    clockIn: '打卡',
    dashboard: '儀表板',
    users: '使用者',
    locations: '地點',
    inventory: '庫存',
    stations: '工作站',
    settings: '設置',
    supervisor: '儀表板',
    operator: '待辦池',
    production: '生產',
    productionEntry: '生產錄入',
    mobileView: '移動視圖',
    desktopView: '桌面視圖',
    reports: '報表',
    productCatalog: '儀表板',
    itemCatalog: '儀表板',
    cameraManagement: '相機管理',
    cameraMonitoringDashboard: '相機監控儀表板',
    labelManagement: '標籤管理',
    transferVerification: '收貨',
    transferHistory: '轉倉記錄',
    productionAssignments: '生產指派',
    materialConsumption: '材料消耗',
    dailyGuide: '生產指南',
    managerDashboard: '儀表板',
    endOfDaySummary: '每日生產總結',
    overrideHistory: '覆核記錄',
    warehouseTransfer: '轉移',
    approvalQueue: '審批佇列',
    boxSearch: '箱子查詢',
    yieldVariance: '良率差異',
    approvalHistory: '審批歷史',
    itemSummaryReport: '項目摘要',
    logout: '登出',
    language: '語言',
    dailyWorkQueue: '每日工作排程',
    workSchedule: '工作排程',
    schedule: '排程',
    byproductMapping: '產品對應',
    productionRecords: '生產記錄',
    productionProgress: '生產進度',
    devTools: '開發工具',
    tutorial: '教學',
    notifications: '通知',
    noNotifications: '沒有通知',
  },

  // Schedule page (combined view)
  schedule: {
    weeklyView: '週視圖',
    dailyQueue: '每日排程',
  },

  dailyWorkQueue: {
    title: '每日工作排程',
    subtitle: '查看並追蹤每日生產子工單',
    status: '狀態',
    station: '工作站',
    operator: '操作員',
    packer: '包裝員',
    product: '產品',
    expectedBoxes: '預計箱數',
    producedBoxes: '已生產箱數',
    scheduledDate: '排程日期',
    subSession: '子工單 #',
    sessionNumber: '工單 #',
    noData: '所選日期範圍內無子工單。',
    unassigned: '未指派',
    today: '今天',
    allStatuses: '所有狀態',
    scheduledWorkforce: '已排班人員',
    operators: '操作員',
    packers: '包裝員',
    stations: '工作站',
    availableOf: '可用',
    noStation: '無工作站',
    assigned: '已指派',
    scheduledStations: '今日排班',
    clickToAssign: '分配',
    assignStation: '分配工作站',
    assignOperator: '分配操作員',
    assignPacker: '分配包裝員',
    selectStation: '選擇工作站',
    selectOperator: '選擇操作員',
    selectPacker: '選擇包裝員',
    assignedSuccess: '分配成功',
    noAvailable: '沒有可用的選項',
    clickToReassign: '點擊重新分配',
    reassignStation: '重新分配工站',
    reassignOperator: '重新分配操作員',
    reassignPacker: '重新分配包裝員',
    currentAssignee: '目前',
  },

  // Manager
  manager: {
    dashboard: '儀表板',
    dashboardSubtitle: '監控生產並管理工單',
    vb6TransferReminders: '待刪除的VB6調撥單',
    vb6TransferRemindersDesc: '以下已取消的工單有已提交的調撥單，需要在VB6系統中刪除。',
    transferReminderDismissed: '提醒已關閉',
    transferReminderResolved: '調撥單已確認刪除',
    markResolved: '標記已解決',
    excessiveReprintsAlert: '檢測到過多標籤重印',
    reprints: '次重印',
    reprintAlertResolved: '重印提醒已解決',
    draftTransferReminder: '轉移至HTE尚未提交',
    todaysSessions: '今日工單',
    plannedSessions: '已提交',
    activeSessions: '進行中',
    completedSessions: '已完成',
    quickActions: '快速操作',
    manageSessionsDesc: '建立和管理生產工單',
    stationsActive: '運作中',
    viewInventoryDesc: '檢視原料和庫存',
    todaysWorkforce: '今日人力',
    operators: '操作員',
    packers: '包裝員',
    stations: '工作站',
    remainingMaterialLots: '原料批次',
    lots: '批次',
    weight: '重量',
    sessions: '工單',
    stationOverview: '工作站概覽',
    sessionOverview: '工單概覽',
    stationView: '工站視圖',
    sessionView: '工單視圖',
    productionProgressOverview: '生產進度概覽',
    overall: '總體',
    noSessionsToday: '今日無排定的生產工單',
    operator: '操作員',
    packer: '包裝員',
    boxes: '箱',
    lbs: '磅',
    noActiveSession: '無進行中工單',
    todaysOutput: '今日產出',
    input: '投入',
    output: '產出',
    avgYield: '平均良率',
    expected: '預期產出',
    completion: '完成率',
    // KPI detail modal
    kpiDetail: {
      sessionsTitle: '今日工單明細',
      workforceTitle: '今日人力明細',
      lotsTitle: '原料批次明細',
      outputTitle: '今日產出明細',
      sessionNumber: '工單編號',
      product: '產品',
      status: '狀態',
      subSessions: '子工單',
      submitted: '已提交',
      received: '已收到',
      planned: '已收到',
      active: '進行中',
      completed: '已完成',
      employeeNumber: '員工編號',
      name: '姓名',
      role: '角色',
      stationName: '工作站',
      type: '類型',
      itemNumber: '品項編號',
      itemName: '品項名稱',
      weightLbs: '重量 (磅)',
      location: '位置',
      receivedDate: '收貨日期',
      outputBoxes: '產出 (箱)',
      expectedBoxes: '預期 (箱)',
      completionPct: '完成率 %',
      noData: '無可用資料',
      clickToViewDetails: '點擊查看詳情',
      loading: '載入中...',
      operatorsSection: '操作員',
      packersSection: '包裝員',
      stationsSection: '工作站',
      rowNumber: '#',
      cases: '箱數',
    },
  },

  // Transfer History
  transferHistory: {
    subtitle: '查看已驗收的轉倉記錄',
  },

  productionProgress: {
    activeStations: '活動工作站',
    boxesPacked: '已包裝箱數',
    totalWeight: '總重量',
    avgOutput: '平均產出',
    all: '全部',
    station: '工作站',
    queue: '排隊',
    product: '產品',
    operator: '操作員',
    packer: '包裝員',
    status_header: '狀態',
    boxes: '箱數',
    progress: '進度',
    weight: '重量 (磅)',
    elapsed: '已用時間',
    noSessions: '此日期沒有生產工單',
    status: {
      active: '進行中',
      paused: '已暫停',
      ready: '就緒',
      received: '已收到',
      submitted: '已提交',
      planned: '已收到',
      pending: '待處理',
      completed: '已完成',
      cancelled: '已取消',
    },
  },

  productionRecords: {
    subtitle: '查看ICS生產記錄和HTE暫存資料',
    source: '來源',
    syncStatus: '同步狀態',
    pending: '待同步',
    synced: '已同步',
    failed: '失敗',
    allSources: '所有來源',
    inputMaterials: '輸入材料',
    outputProducts: '產出產品',
    weightEntries: '重量記錄',
    noRecords: '找不到生產記錄',
    sessionLink: '查看工作階段',
    detailCount: '明細行',
    productionNumber: '生產單號',
    dateRange: '日期範圍',
    operator: '操作員',
    location: '位置',
    createdBy: '建立者',
    // Detail view
    title: '生產記錄',
    productionNo: '生產編號',
    printBarcodes: '列印條碼',
    printBarcodesPopupBlocked: '彈出視窗被封鎖 — 請允許彈出視窗以列印條碼',
    printBarcodesFailed: '無法載入條碼',
    requestDate: '申請日期',
    finishDate: '完成日期',
    productionComplete: '生產完成',
    productionLocation: '生產地點',
    memo: '附註',
    inputTab: '投入材料',
    outputTab: '輸出成品',
    quantity: '申請數量',
    quantityShipped: '運送數量',
    weightShipped: '重量',
    warehouseCol: '倉庫',
    locationCol: '存放',
    referenceNo: '參考編號',
    unitPrice: '單價',
    amount: '金額',
    materialDocNo: '原料文件號碼',
    materialDocType: '原料文件類型',
    eItem: 'E-項目',
    backToList: '返回列表',
    notFound: '找不到生產記錄',
    loadFailed: '無法載入生產記錄',
  },

  // Dashboard
  dashboard: {
    title: '儀表板',
    welcome: '歡迎',
    overview: '系統概覽',
    activeUsers: '活躍使用者',
    activeStations: '活躍工作站',
    todayProduction: '今日生產',
    alerts: '警示',
    recentActivity: '最近活動',
    statistics: '統計',
    performance: '績效',
  },

  // Users
  users: {
    title: '使用者管理',
    addUser: '新增使用者',
    editUser: '編輯使用者',
    deleteUser: '刪除使用者',
    userDetails: '使用者詳情',
    userId: '使用者編號',
    fullName: '姓名',
    userLevel: '使用者等級',
    location: '地點',
    department: '部門',
    email: '電子郵件',
    phone: '電話',
    createdAt: '建立時間',
    lastLogin: '最後登入',
    permissions: '權限',
    role: '角色',
    admin: '管理員',
    supervisor: '主管',
    operator: '操作員',
    userCount: '總使用者數',
    activeCount: '活躍使用者',
    searchUsers: '尋找使用者...',
  },

  // Locations
  locations: {
    title: '地點管理',
    addLocation: '新增地點',
    editLocation: '編輯地點',
    deleteLocation: '刪除地點',
    locationDetails: '地點詳情',
    locationId: '地點編號',
    locationCode: '地點代碼',
    locationName: '地點名稱',
    description: '描述',
    address: '地址',
    manager: '經理',
    capacity: '容量',
    stationCount: '工作站',
    searchLocations: '尋找地點...',
  },

  // Stations
  stations: {
    title: '工作站管理',
    addStation: '新增工作站',
    editStation: '編輯工作站',
    deleteStation: '刪除工作站',
    stationDetails: '工作站詳情',
    stationId: '工作站編號',
    stationName: '工作站名稱',
    stationType: '工作站類型',
    location: '地點',
    assignedOperator: '指派操作員',
    currentProduction: '目前生產',
    targetProduction: '目標生產',
    efficiency: '效率',
    searchStations: '尋找工作站...',
    printerMac: '印表機 MAC 位址',
    printerMacDesc: '指派給此工作站的 Zebra 印表機 MAC 位址',
    printerStatus: '印表機狀態',
    printerConnected: '已連線',
    printerNotFound: '未找到',
    printerNotAssigned: '未指派印表機',
    assignPrinter: '指派印表機',
    removePrinter: '移除印表機',
    discoverPrinters: '探索印表機',
    testPrint: '測試列印',
    testPrintSuccess: '測試標籤已成功發送至印表機',
    testPrintFailed: '測試列印失敗',
    printerMacPlaceholder: 'XX:XX:XX:XX:XX:XX',
    discovering: '探索中...',
    noPrintersFound: '網路上未找到印表機',
    selectPrinter: '選擇要指派的印表機',
    printerAssigned: '印表機指派成功',
    printerRemoved: '印表機已移除',
    printerLinkError: '儲存印表機指派失敗 — 此站台可能沒有已指派的印表機',
  },

  // Inventory
  inventory: {
    title: '庫存管理',
    dashboard: '庫存儀表板',
    productCatalog: '儀表板',
    itemCatalog: '儀表板',
    browseManageItems: '瀏覽和管理所有庫存項目',
    addNewItem: '新增項目',
    itemType: '項目類型',
    allItems: '所有項目',
    rawMaterials: '原料',
    finishedProducts: '成品',
    searchItems: '尋找項目',
    searchByItemNumber: '按項目編號或名稱尋找...',
    allLocations: '所有地點',
    itemName: '項目名稱',
    itemNumber: '品號',
    stock: '庫存',
    outOfStock: '缺貨',
    lowStock: '庫存不足',
    inStock: '有庫存',
    viewDetails: '查看詳情',
    loadingItems: '載入項目中...',
    failedToLoadItems: '載入項目失敗',
    noItemsFound: '找不到項目',
    finishedGoods: '成品',
    stockLevel: '庫存量',
    reorderPoint: '再訂購點',
    supplier: '供應商',
    category: '類別',
    sku: '品號',
    barcode: '條碼',
    quantity: '數量',
    unit: '單位',
    weight: '重量',
    price: '價格',
    cost: '成本',
    lastUpdated: '最後更新',
    updatedAt: '更新時間',
    updatedBy: '更新者',
    searchInventory: '尋找庫存...',
    // Lot inventory
    availableLots: '可用批次',
    expiringSoon: '即將過期',
    within7Days: '7天內',
    packedBoxes: '已包裝箱子',
    boxesToday: '今日箱數',
    shipped: '已發貨',
    rawMaterialLots: '原料批次',
    allStatuses: '所有狀態',
    statusAvailable: '可用',
    statusReserved: '已預留',
    statusDepleted: '已用完',
    statusPacked: '已包裝',
    statusShipped: '已發貨',
    statusVoided: '已作廢',
    statusRejected: '已拒絕',
    statusOn_hold: '暫停中',
    statusConsumed: '已消耗',
    statusRemainder: '剩餘物料',
    statusByProduct: '副產品',
    statusByProductM: '副產品（可銷售）',
    statusByProductP: '副產品（生產用）',
    statusFinishProductNi: '成品 - 非完整',
    marketableByproduct: '可銷售副產品',
    onHoldApproved: '待用（已核准）',
    onHoldPending: '待用（待核准）',
    lotNumber: '批號',
    currentWeight: '重量',
    allocatedToSession: '已分配至工單',
    expiryDate: '到期日',
    receivedDate: '接收日期',
    receivedBy: '收貨人',
    productName: '產品名稱',
    packedAt: '包裝時間',
    boxCount: '箱數',
    boxCountNote: '包含已取消的箱',
    expectedCount: '預期',
    totalWeight: '總重量',
    lastPacked: '最後包裝',
    yieldFactor: '產出率',
    // Raw Material Receiving
    addRawMaterial: '新增原料',
    receiveRawMaterial: '接收原料',
    scanTransferNumber: '掃描轉移編號',
    enterTransferNumber: '輸入或掃描轉移編號...',
    transferInfo: '轉移資訊',
    transferNumber: '轉移編號',
    transferDate: '轉移日期',
    fromLocation: '來源位置',
    toLocation: '目的位置',
    noTransferFound: '找不到此轉移編號',
    transferNotFound: '找不到轉移',
    startScanningBoxes: '開始掃描箱子',
    scanBoxes: '掃描箱子',
    scanBoxBarcode: '掃描箱子條碼...',
    boxesScanned: '已掃描箱數',
    removeBox: '移除',
    confirmReceiving: '確認接收',
    confirmReceivingMessage: '您即將接收以下原料：',
    receivingSuccess: '原料接收成功',
    receivingError: '接收原料失敗',
    invalidTransfer: '無效的轉移編號',
    selectExpiryDate: '選擇到期日',
    boxes: '箱',
    lbs: '磅',
    back: '返回',
    confirmAndSave: '確認並儲存',
    scanningBoxesFor: '正在掃描',
    noBoxesScanned: '尚未掃描任何箱子',
    scanBoxToAdd: '掃描箱子條碼以添加到列表',
    itemsInTransfer: '轉移中的項目',
    expectedQuantity: '預期數量',
    expectedWeight: '預期重量',
    productNotInTransfer: '此轉移中找不到該產品',
    invalidBarcode: '無效的條碼格式',
    alreadyReceived: '已接收',
    pending: '待處理',
    itemAlreadyReceived: '此物品已從該轉移中接收',
    // Box Lookup
    boxLookup: '箱子查詢',
    boxLookupSearchPlaceholder: '輸入或掃描條碼...',
    boxLookupSearch: '尋找',
    boxLookupNoResults: '未找到此條碼的箱子',
    boxLookupError: '查詢條碼失敗',
    boxLookupProductSku: '品項編號',
    boxLookupRawMaterial: '原物料',
    boxLookupBoxNumber: '箱號',
    boxLookupWeight: '重量',
    boxLookupStation: '工作站',
    boxLookupOperator: '操作員',
    boxLookupPacker: '包裝員',
    boxLookupEmployeeNumber: '員工編號',
    boxLookupSession: '生產工單',
    boxLookupLot: '批號',
    boxLookupPackedAt: '包裝時間',
    boxLookupPrintedAt: '標籤列印時間',
    boxLookupPackedAndLabeledAt: '包裝及標籤時間',
    boxLookupStatus: '狀態',
    boxLookupBarcode: '條碼',
    boxLookupNotAvailable: '無',
    // Marketable By-Product (buffer / case) Lookup
    bufferFound: '可銷售副產品（緩衝區）',
    caseFound: '可銷售副產品（箱）',
    bufferSourceMaterial: '來源原料',
    bufferReservedWeight: '重量',
    bufferSubSession: '子工段',
    bufferProductionDate: '生產日期',
    // Raw Material Lookup
    rawMaterialFound: '原物料',
    rawMaterialItemNumber: '物料編號',
    rawMaterialGtin: 'GTIN',
    rawMaterialLot: '批號',
    rawMaterialWeight: '掃描重量',
    rawMaterialBrand: '品牌',
    rawMaterialYieldFactor: '產出率',
    // Transaction History tab
    transactionHistory: '交易紀錄',
    transactionType: '類型',
    allTypes: '所有類型',
    change: '變動',
    balance: '餘額',
    noTransactions: '未找到交易紀錄',
    transactionSessionStart: '開始生產',
    transactionSessionCancel: '取消生產',
    transactionSessionComplete: '完成生產',
    transactionCasePacked: '裝箱',
    transactionCaseCancelled: '取消箱',
    transactionCaseVoided: '作廢箱',
    transactionCasePending: '待裝箱',
    transactionWasteRecorded: '記錄廢料',
    transactionManualAdjustment: '手動調整',
    transactionOracleSync: 'Oracle 同步',
    transactionMaterialIssue: '領料',
    transactionLotReceived: '批次入庫',
    transactionLotRejected: '批次拒收',
    transactionLotReserved: '批次預留',
    transactionByProductReceived: '副產品',
    transactionByProductMarketableReceived: '副產品 (可售)',
    transactionByProductProductionReceived: '副產品 (生產用)',
    transactionRemainderReceived: '剩餘物料',
    transactionRemainderIntactReceived: '剩餘物料 (完整)',
    transactionRemainderNotIntactReceived: '剩餘物料 (不完整)',
    transactionByProductMarketablePrinted: '副產品（可銷售）標籤列印',
    transactionByProductCasePrinted: '副產品（可銷售）箱標籤列印',
    transactionFinishProductNotIntactReserved: '成品（不完整）保留待轉移',
    transactionFinishProductNotIntactReceived: '成品（不完整）已接收',

    scanDetails: '掃描明細',
    box: '箱',
    noScanDetails: '此批次無掃描明細',
    remark: '備註',
    scannedAt: '掃描時間',

    // Packing Materials tab
    packingMaterials: '包裝材料',
    totalPackingItems: '包裝品項',
    totalPackingLots: '包裝批次',
    lowStockItems: '低/零庫存',
    linkedProducts: '關聯產品',
  },

  // Production
  production: {
    title: '生產',
    assignments: '生產分配',
    schedule: '生產排程',
    batch: '批次',
    batchNumber: '批號',
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '持續時間',
    producedQuantity: '生產數量',
    targetQuantity: '目標數量',
    progress: '進度',
    materials: '物料',
    consumption: '物料消耗',
    yield: '良率',
    expectedYield: '預期良率',
    actualYield: '實際良率',
    waste: '損耗',
    notes: '備註',
    remnantAvailable: '有剩餘原料',
  },

  // Settings
  settings: {
    title: '設定',
    general: '一般設定',
    system: '系統設定',
    appearance: '外觀',
    language: '語言',
    theme: '主題',
    notifications: '通知',
    security: '安全性',
    backupRestore: '備份與還原',
    about: '關於',
    version: '版本',
  },

  // Validation
  validation: {
    required: '此欄位為必填',
    invalidEmail: '電子郵件格式錯誤',
    invalidPhone: '電話號碼格式錯誤',
    minLength: '最少需要 {{min}} 個字元',
    maxLength: '最多 {{max}} 個字元',
    passwordMismatch: '密碼不符',
    invalidFormat: '格式錯誤',
    mustBeNumber: '必須為數字',
    mustBePositive: '必須為正數',
  },

  // Messages
  messages: {
    saveSuccess: '儲存成功',
    deleteSuccess: '刪除成功',
    updateSuccess: '更新成功',
    createSuccess: '建立成功',
    deleteConfirm: '確定要刪除此項目嗎？',
    unsavedChanges: '您有未儲存的變更，確定要離開嗎？',
    operationFailed: '操作失敗',
    networkError: '網路錯誤，請檢查您的連線。',
    serverError: '伺服器錯誤，請稍後再試。',
    loadFailed: '無法載入{item}。部分功能可能使用預設值。',
    refreshFailed: '無法重新整理資料。請重新載入頁面。',
    noData: '無資料',
    noResults: '無尋找結果',
  },

  // Date & Time
  dateTime: {
    date: '日期',
    time: '時間',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本週',
    thisMonth: '本月',
    lastWeek: '上週',
    lastMonth: '上月',
    customRange: '自訂範圍',
    from: '從',
    to: '到',
  },

  // Operator
  operator: {
    // Production Entry
    packBoxes: '包裝箱子',
    stationAssigned: '工作站已指派',
    productionSessionAssigned: '生產工作已指派到您的工作站',
    noStationAssignment: '無工作站指派',
    noSessionAssigned: '您目前沒有生產工作指派到工作站。',
    contactSupervisor: '請聯絡您的主管指派生產工作。',
    enterPackageWeight: '輸入包裝重量',
    printAndPackBox: '列印並包裝箱子',
    printAndPackSubUnit: '列印並包裝子單位',
    packSubUnit: '包裝子單位',
    subUnit: '子單位',
    masterBox: '主箱',
    weighMasterBoxPrompt: '所有子單位已秤重。現在秤重主箱。',
    nowWeighTheBox: '現在秤重包含所有子單位的箱子',
    continue: '繼續',
    subUnitWeightMissing: '產品資料不完整 - 未設定子單位重量。請聯絡主管。',
    subUnitPacked: '子單位已包裝！',
    printing: '列印中...',
    target: '目標',
    scaleReading: '秤重讀數',
    readyForWeighing: '準備秤重',
    acceptable: '可接受',
    productionPausedResume: '生產已暫停 - 點擊「繼續」以恢復',
    clickStartProduction: '點擊「開始」以開始生產',

    // Scale Weight component
    targetWeightScale: '目標重量',
    tareButton: '去皮/歸零秤重（重設包裝重量）',
    targetReachedMsg: '達到目標 - 不允許繼續包裝',
    targetUnreachedMsg: '將空包裝放在秤上並點擊以歸零',
    weightAcceptable: '重量可接受',
    invalidWeightNegative: '重量無效（負數）',
    overTarget: '超過目標',
    underTarget: '低於目標',
    acceptableRangeLabel: '可接受範圍',
    removeContentsReweigh: '移除內容物並重新秤重',
    addContentsReweigh: '添加內容物並重新秤重',

    // Metrics
    boxesPacked: '已包裝箱數',
    estimated: '預估',
    totalOutput: '總產出',
    outputProgress: '產量進度',
    recentBoxes: '最近箱子',
    boxNumber: '箱號',
    weight: '重量',
    time: '時間',
    tolerance: '公差',

    // Session Info
    sessionInfo: '工作階段資訊',
    product: '產品',
    itemNumber: '物品編號',
    station: '工作站',
    lot: '批次',
    supervisor: '主管',
    initialMaterial: '初始材料',
    usableMaterial: '可用材料',
    rawMaterial: '原材料',
    targetWeight: '目標重量/箱',
    targetOutput: '目標',

    // Session Time & Material Details
    sessionTime: '工作時間',
    startedAt: '開始時間',
    materialDetails: '材料詳情',
    initialMaterialWeight: '初始材料重量',
    targetOutputWeight: '目標產出重量',
    actualOutputWeight: '實際產出重量',
    yieldRate: '良率',
    yield: '良率',
    completionRate: '完成率',
    weightModeChanged: '重量模式已更改為',

    // Quality Control
    qualityControlCheck: '品質控制檢查',
    completeAllChecks: '包裝箱子前完成所有品質檢查',
    visualInspection: '外觀檢查',
    weightVerified: '重量驗證',
    labelingCorrect: '標籤正確',
    packagingIntact: '包裝完整',
    checkAll: '全選',
    uncheckAll: '全不選',
    qualityChecksCompleted: '品質檢查完成',

    // Quality descriptions
    qualityDescVisual: '產品外觀新鮮，無變色或損壞',
    qualityDescWeight: '重量為',
    qualityDescLabeling: '標籤清晰列印，批號和重量正確',
    qualityDescPackaging: '包裝無撕裂、穿孔或缺陷',

    // Packing Confirmation
    confirmPacking: '確認包裝',
    labelPrinted: '標籤已成功列印',
    verifyBeforePacking: '確認前請驗證以下內容',
    boxWeight: '箱子重量',
    withinTolerance: '在公差範圍內',
    allQualityChecksPassed: '所有品質檢查已通過',
    confirmAndPack: '確認並包裝',

    // Label Applied Confirmation
    confirmLabelApplied: '確認標籤已貼上',
    labelsPrinted: '已列印 {{count}} 份標籤',
    confirmLabelAppliedDescription: '請確認標籤已正確貼在箱子上後再繼續。',

    // Shipping
    ship: '出貨',
    shipped: '已出貨',
    selectShippingLocation: '選擇此箱子的出貨目的地。',
    shippingLocationRequired: '選擇出貨地點（必填）...',
    confirmShip: '確認出貨',
    shipping: '出貨中...',
    shippedTo: '運往',

    // Locations
    warehouseA: '倉庫 A',
    warehouseB: '倉庫 B',
    warehouseC: '倉庫 C',
    distributionCenter1: '配送中心 1',
    distributionCenter2: '配送中心 2',
    coldStorage: '冷藏庫',
    retailStore: '零售店',
    customerDirect: '直送客戶',

    // Session Control
    start: '開始',
    pause: '暫停',
    resume: '繼續',
    complete: '完成',
    startSession: '開始工作',
    pauseSession: '暫停工作',
    resumeSession: '繼續工作',
    completeSession: '完成工作',
    starting: '開始中...',
    pausing: '暫停中...',
    resuming: '繼續中...',
    completing: '完成中...',
    pauseProductionSession: '暫停生產工作',
    reviewProgressAndReason: '檢視當前進度並提供暫停原因。',
    selectPauseReason: '選擇暫停原因（必填）...',
    selectCompletionReason: '選擇完成原因...',
    addFinalNotes: '新增最終備註或觀察（選填）...',

    // Status Messages
    sessionStarted: '工作已成功開始',
    sessionPaused: '工作已暫停',
    sessionResumed: '工作已繼續',
    sessionCompleted: '工作已成功完成',
    missionAccomplished: '任務完成！',
    betterThanExpected: '超越預期！',
    ofTargetCompleted: '目標完成',
    unassign: '取消分配',
    unassignConfirm: '取消分配？',
    unassignMessage: '確定要取消分配嗎？工作將返回待辦池。',
    unassignSuccess: '已取消分配',
    cancelAssignment: '取消',
    cancelAssignmentConfirm: '取消分配？',
    cancelAssignmentMessage: '確定要取消此分配嗎？您可以從待辦池中重新分配。',
    cancelAssignmentSuccess: '已取消分配',
    boxMarkedAsShipped: '箱子已標記為出貨',
    providePauseReason: '請提供暫停原因',
    selectShippingLocationError: '請選擇出貨地點',
    noBoxSelected: '未選擇箱子',

    // Pause Reasons
    breakTime: '休息時間',
    equipmentIssue: '設備問題',
    materialShortage: '材料短缺',
    qualityIssue: '品質問題',
    shiftChange: '換班',
    maintenance: '維護',
    other: '其他',

    // Complete Reasons
    targetReached: '達到目標產量',
    notYetReached: '尚未達成',
    endOfShift: '下班時間',
    materialDepleted: '材料用盡',
    qualityIssues: '品質問題',
    maintenanceRequired: '設備需要維護',
    orderComplete: '生產訂單完成',

    // Waste Tracking
    wasteTracking: '損耗追蹤',
    recordWaste: '記錄損耗',
    recording: '記錄中...',
    totalWaste: '總損耗',
    wastePercentage: '損耗 %',
    ofMaterial: '佔原料',
    materialUsed: '已使用材料',
    wasteType: '損耗類型',
    wasteTypeRequired: '損耗類型 *',
    weightLbs: '重量（磅）',
    weightLbsRequired: '重量（磅）*',
    disposalMethod: '處理方式',
    disposalMethodRequired: '處理方式 *',
    reasonNotes: '原因／備註',
    optionalDescription: '選填說明...',
    wasteRecords: '損耗記錄',
    wasteSummary: '損耗摘要',
    noWasteRecorded: '此工作無損耗記錄',
    remainingMaterial: '剩餘材料',
    totalRemaining: '剩餘總量',
    recorded: '記錄時間',
    entries: '筆',
    deleteWasteConfirm: '確定要刪除此損耗記錄嗎？',
    deleteWasteRecord: '刪除損耗記錄',
    wasteRecordedSuccess: '損耗記錄成功',
    wasteRecordedFailed: '記錄損耗失敗',
    wasteDeletedSuccess: '損耗記錄已刪除',
    wasteDeletedFailed: '刪除損耗記錄失敗',
    enterValidWeight: '請輸入有效重量',
    finishSession: '完成工作',
    sessionSummary: '工作摘要',
    completionReason: '完成原因',
    recordWasteFirst: '完成前請至少記錄一筆損耗',

    // Waste Types
    trim: '修整',
    damagedProduct: '損壞產品',
    processingLoss: '加工損耗',
    wasteTypeByProduct: '副產品',
    wasteTypeDisposable: '廢棄物',
    wasteTypeHumanError: '人為錯誤',
    humanErrorTrackingOnly: '僅追蹤',
    wasteTypeWaterLiquid: '水/液體',
    wasteTypeRemainder: '剩餘物',
    wasteTypeRemainderIntact: '剩餘物 - 完整',
    wasteTypeRemainderNotIntact: '剩餘物 - 已開封',
    remainderIntactDesc: '仍密封在原箱中',
    remainderNotIntactDesc: '已開封/部分材料',
    // Waste tracking sections
    actualWaste: '實際廢棄物',
    countsAsWaste: '計入廢棄物',
    returnsToInventory: '歸還庫存',
    productionRemainder: '生產剩餘',
    notWaste: '非廢棄物',
    createsNewLot: '創建新批次',
    addsBackToLot: '加回原批次',
    selectMaterial: '選擇材料...',
    autoCalculated: '自動計算',
    enterAllWasteWeights: '輸入所有廢棄物重量（必填，如無則輸入0）',
    fillAllWasteFields: '請填寫所有廢棄物重量欄位',

    // Yield Variance Approval (supervisor verification when variance > 2%)
    yieldVarianceDetected: '檢測到良率差異',
    yieldVarianceMessage: '實際良率與預期相差超過2%。需要主管批准。',
    expectedYield: '預期良率',
    actualYield: '實際良率',
    supervisorApproval: '主管批准',
    scanSupervisorBadge: '掃描主管證件以批准',
    waitingForBadgeScan: '等待掃描證件...',
    supervisorVerified: '主管已驗證',
    invalidSupervisorBadge: '主管證件無效',
    supervisorLogin: '主管登入',
    supervisorUsername: '用戶名',
    supervisorPassword: '密碼',
    varianceReason: '差異原因',
    varianceReasonPlaceholder: '說明良率與預期不同的原因...',
    approveAndComplete: '批准並完成',
    invalidSupervisorCredentials: '主管憑證無效',
    notAuthorizedSupervisor: '用戶未被授權為主管',
    reasonRequired: '原因為必填',
    verifyingCredentials: '驗證中...',
    yieldVariance: '差異',

    // Remainder-specific (raw material selection) - deprecated
    unusedRawMaterial: '未使用原料',
    selectRawMaterial: '選擇原料',
    selectRawMaterialRequired: '請為剩餘物選擇原料',
    allRemaindersRecorded: '所有原料已記錄剩餘物',
    noRawMaterialsLinked: '此工作階段未連結原料',

    // Disposal Methods
    compost: '堆肥',
    animalFeed: '動物飼料',
    landfill: '垃圾掩埋',
    incineration: '焚化',
    recycling: '回收',

    // Session Pool
    availableSessions: '可用工作池',
    selectSessionToWork: '選擇一個工作開始作業',
    availableSessionsCount: '個可用工作',
    refresh: '重新整理',
    loadingAvailableSessions: '載入可用工作中...',
    noAvailableSessions: '無可用工作',
    noSessionsInPool: '目前池中沒有可用的工作。',
    checkBackLater: '請稍後再查看或聯絡主管。',
    sessionNumber: '工作 #',
    available: '可用',
    assignToMe: '指派給我',
    inQueue: '排隊中',
    sessionReady: '就緒',
    waitingInQueue: '排隊中',
    waitingForAssignment: '等待分配',
    assigning: '指派中...',
    youHaveActiveSession: '您有進行中的工作',
    completeCurrentSession: '從池中領取新工作前，請先完成當前工作。',
    goToProductionEntry: '前往生產錄入',
    confirmAssignment: '確認工作指派',
    confirmAssignmentMessage: '確定要將此工作指派給自己嗎？',
    oneSessionOnly: '您一次只能有一個進行中的工作。',
    authorizedBy: '授權人',
    created: '已創建',
    scheduledDate: '排程日期',
    weekOf: '週',
    sessionNotScheduledToday: '此工作階段未排定在今天',
    viewDetails: '查看',
    hideDetails: '隱藏',
    confirm: '確認',

    // Session History
    sessionHistory: '工作歷史',
    viewPastSessions: '查看您過去的生產工作和績效',
    pastSessions: '過去工作',
    page: '頁',
    noSessionHistory: '未找到工作歷史',
    outputProduced: '產出',
    wasteGenerated: '損耗',
    started: '開始',
    completed: '完成',

    // Performance Dashboard
    performanceDashboard: '績效儀表板',
    welcomeBack: '歡迎回來，',
    loadingPerformanceData: '載入績效數據中...',
    period: '期間',
    week: '週',
    month: '月',
    sessions: '工作',
    sessionsCompleted: '已完成工作',
    output: '產量',
    totalWeightProduced: '總生產重量',
    averageYield: '平均良率',
    averageYieldPercentage: '平均良率百分比',
    wasteRatio: '損耗比例',
    products: '產品',
    differentProducts: '不同產品',
    personalBest: '個人最佳',
    recentSessions: '近期工作',
    duration: '時長',
    noSessionsFound: '未找到工作',

    // Operator Dashboard
    operatorDashboard: '操作員儀表板',
    currentSession: '當前工作',
    noActiveSession: '無進行中工作',
    noSessionYet: '您尚未被指派生產工作，請聯絡主管。',
    noAssignedSession: '目前沒有指派給您的生產工作。',
    contactSupervisorForSession: '請聯絡主管以指派工作。',
    boxesCompleted: '已完成箱數',
    timeRunning: '運行時間',
    recordProduction: '記錄生產',
    sessionsToday: '今日工作',
    notStarted: '未開始',
    loading: '載入中...',
    performanceStats: '績效統計',
    today: '今日',
    thisWeek: '本週',
    thisMonth: '本月',
    sessionsWorked: '已完成工作數',
    avgYield: '平均良率',
    waste: '廢料',
    productInfo: '產品資訊',
    sku: 'SKU',
    material: '原料',
    initialWeight: '初始重量',
    productionProgress: '生產進度',
    actual: '實際',
    pauseSessionDescription: '請提供暫停工作的原因',
    selectReason: '選擇原因...',
    sessionStartedSuccess: '工作已成功啟動',
    sessionStartedFailed: '啟動工作失敗',
    sessionPausedSuccess: '工作已暫停',
    sessionPausedFailed: '暫停工作失敗',
    sessionResumedSuccess: '工作已恢復',
    sessionResumedFailed: '恢復工作失敗',

    // Status
    packed: '已包裝',
    cancelled: '已取消',
    pending: '待處理',
    submitted: '已提交',
    received: '已收到',
    planned: '已收到',

    // Common
    lbs: '磅',
    boxes: '箱',
    session: '工作',
    noStationAssigned: '未分配工作站',

    // Scale Connection
    scaleConnecting: '正在連接秤...',
    scaleConnected: '秤已連接',
    scaleDisconnected: '秤已斷開連接',
    scaleConnectionError: '秤連接錯誤',
    scaleReconnecting: '正在重新連接秤...',
    scaleConnectionLost: '連接丟失。已達到最大重連次數。',
    scaleWeightStable: '重量穩定',
    scaleWeightUnstable: '重量不穩定',
    scaleLastUpdate: '最後更新',
    scaleTareCommand: '去皮',
    scaleNotConnected: '秤未連接',
    autoMode: '自動模式',
    manualMode: '手動模式',
    scaleMode: '秤重',
    captureWeight: '擷取',
    scaleConnectedWaste: '秤已連接',
    scaleDisconnectedWaste: '秤已斷開',
    stable: '穩定',
    unaccountedMaterial: '未計算材料',
    allMaterialAccounted: '所有材料已計算完成！',
    trackRemainingWaste: '追蹤剩餘廢料以完成工作階段',
  },

  // Supervisor
  supervisor: {
    supervisor: '主管',
    dashboard: '主管儀表板',
    realtimeMonitoring: '即時生產監控和控制',
    activeStations: '活躍工作站',
    totalStations: '總工作站',
    activeSessions: '進行中工作',
    plannedSessions: '已提交工作',
    completedSessions: '已完成工單',
    cancelledSessions: '已取消工單',
    productionInProgress: '生產進行中',
    awaitingStart: '等待開始',
    todaysProduction: '今日生產',
    boxes: '箱',
    totalWeight: '總重量',
    yieldRate: '良率',
    productionVsTarget: '生產對比目標',
    pendingAlerts: '待處理警示',
    requiresAttention: '需要注意',
    dismissAlerts: '關閉警示',
    clickToShowAlerts: '點擊顯示警示',
    supervisorDashboard: '主管儀表板',
    allLocations: '所有地點',
    refresh: '刷新',
    quickActions: '快速操作',
    quickStats: '快速統計',
    setWeeklyOperatorSchedule: '設定每週操作員排班',
    openStations: '開啟工作站',
    openStationsDescription: '對所有工作站執行自動提升',
    promotionResults: '提升結果',
    promotedSessions: '以下工作階段已提升為就緒：',
    noPromotions: '沒有工作階段可以提升。所有工作站要麼正在使用中，沒有排隊的工作階段，或工作階段缺少操作員/材料。',
    alert: '警示',
    plural: '',
    requireAttention: '需要注意',
    is: '是',
    hasNoAssignedProduct: '無指派產品',
    loadingStationData: '載入工作站資料...',
    noStationsFound: '未找到工作站',
    station: '工作站',
    active: '活躍',
    progress: '進度',
    type: '類型',
    production: '生產',
    targetWeight: '目標重量',
    assignedProduct: '指派產品',
    rawMaterial: '原材料',
    initialWeight: '初始重量',
    targetOutput: '目標產出',
    actualOutput: '實際產出',
    startedAt: '開始時間',
    yield: '產出率',
    parentSession: '主工單',
    finishedProduct: '成品',
    operator: '操作員',
    packer: '包裝員',
    notAssigned: '未指派',
    reassignOperator: '重新指派操作員',
    isCurrentlyAssignedTo: '目前已指派給',
    doYouWantToReassignTo: '您要將他重新指派到',
    reassign: '重新指派',
    viewDetails: '查看詳情',
    pause: '暫停',
    recentActivity: '最近活動',
    loadingActivities: '載入活動...',
    noRecentActivity: '無最近活動',
    systemEventsWillAppear: '系統事件將即時顯示在此處',
    recentActivityUnderDevelopment: '最近活動功能正在開發中',
    checkBackSoon: '請稍後查看即時活動更新',

    // 行動版工單管理
    sessions: '工單',
    activeAndPlanned: '進行中和計畫中',
    paused: '已暫停',
    completed: '已完成',
    noSessionsFound: '找不到工單',

    // Camera Monitoring
    cameraMonitoringDashboard: '攝影機監控儀表板',
    monitorAllCCTV: '監控所有工作站的CCTV影像',
    totalCameras: '總攝影機數',
    refreshAll: '全部刷新',
    loadingCameras: '載入攝影機...',
    configureFirstCamera: '尚未設定攝影機。請為您的工作站配置攝影機以開始監控。',
    stopViewing: '停止觀看',
    startViewing: '開始觀看',
    fullscreen: '全螢幕',
    stream: '串流',
    requiresMediaServer: '需要媒體伺服器',
    clickEyeToView: '點擊眼睛圖示觀看',
    closeESC: '關閉 (ESC)',

    // Override History
    overrideHistory: '覆核記錄',
    overrideHistoryDesc: '查看所有主管覆核和批准記錄',
    overrideTypes: '覆核類型',
    filters: '篩選',
    dateFrom: '開始日期',
    dateTo: '結束日期',
    overrideType: '覆核類型',
    searchSupervisor: '尋找主管...',
    exportCSV: '匯出 CSV',
    timestamp: '時間戳記',
    session: '工單',
    details: '詳情',
    reason: '原因',
    noOverridesFound: '未找到覆核記錄',
    additionalDetails: '詳細資訊',
    showingResults: '顯示 {{from}}-{{to}} / {{total}}',
    page: '頁',
    labelReprintDesc: '重印箱標籤',
    manualWeightDesc: '手動輸入重量',
    yieldSignoffDesc: '批准產出差異',
    eodSignoffDesc: '日結簽核',
    sessionCompletionDesc: '提前完成工單',
    override_session_completion: '工單完成覆核',
    override_eod_signoff: '日結簽核覆寫',

    // Station Management Page
    loadingStations: '載入工作站...',
    monitorStationsAssignSessions: '監控工作站，分配工作和管理操作員',
    location: '地點',
    product: '產品',
    itemNumber: '物品編號',
    target: '目標',
    started: '開始時間',
    noSessionAssigned: '未分配工作',
    assignedOperator: '已分配操作員',
    noOperatorAssigned: '未分配操作員',
    assignSession: '分配工作',
    changeOperator: '更換操作員',
    assignOperator: '分配操作員',
    startSession: '開始工作',
    pauseSession: '暫停工作',
    resumeSession: '繼續工作',
    completeSession: '完成工作',
    starting: '開始中...',
    pausing: '暫停中...',
    resuming: '繼續中...',
    completing: '完成中...',
    assigning: '分配中...',
    assignSessionTo: '分配工作至',
    warning: '警告',
    stationAlreadyHasSession: '此工作站已有分配的工作。分配新工作將替換當前工作。',
    selectPlannedSession: '選擇已提交工作',
    onlyPlannedSessionsShown: '僅顯示未分配工作站的已提交工作。每個工作站一次只能有一個活躍工作。',
    selectASession: '-- 選擇工作 --',
    assignOperatorTo: '分配操作員至',
    selectOperator: '選擇操作員',
    selectAnOperator: '-- 選擇操作員 --',
    sessionAssignedSuccess: '工作已成功分配至工作站',
    failedToAssignSession: '工作分配失敗',
    operatorAssignedSuccess: '操作員分配成功',
    failedToAssignOperator: '操作員分配失敗',
    sessionStartedSuccess: '工作已成功開始',
    failedToStartSession: '工作開始失敗',
    sessionPausedSuccess: '工作已成功暫停',
    failedToPauseSession: '工作暫停失敗',
    sessionResumedSuccess: '工作已成功繼續',
    failedToResumeSession: '工作繼續失敗',
    sessionCompletedSuccess: '工作已成功完成',
    failedToCompleteSession: '無法完成工作',
    sessionUnplannedSuccess: '工作已成功移除',
    failedToUnplanSession: '工作移除失敗',
    removeSession: '移除工作',
    removingSession: '移除中...',
    showDisabledStations: '顯示已停用',
    hideDisabledStations: '隱藏已停用',

    // Operator Assignment
    assignOperatorNow: '現在分配操作員？',
    sessionAssignedToStation: '工作已分配到 {station}。',
    operatorRequiredToStart: '在開始工作之前必須分配操作員。',
    assignLater: '稍後分配',
    noOperator: '無操作員',
    assignOperatorFirst: '請在開始工作之前分配操作員',

    // Queue and Ready Status
    inQueue: '排隊中',
    sessionReady: '就緒',
    queueCount: '{{count}} 排隊中',
    waitingForAssignment: '等待分配',
    waitingInQueue: '排隊中',

    // Material Restriction
    allowedMaterialType: '允許的原料類型',
    selectMaterialType: '-- 無限制 --',
    materialTypeChicken: '生雞肉',
    materialTypeBeef: '牛肉',
    materialTypePork: '豬肉',
    materialTypeGoatLamb: '羊肉',
    restrictedTo: '限制為',
    materialTypeUpdated: '原料類型限制已成功更新',
    cleaningConfirmationRequired: '需要清潔確認',
    materialChangeWarning: '更改原料類型需要清潔工作站以防止交叉污染。',
    previousType: '之前類型',
    newType: '新類型',
    confirmCleaning: '工作站已正確清潔嗎？',
    cleaningStep1: '所有設備和表面已消毒',
    cleaningStep2: '已去除先前原料殘留',
    cleaningStep3: '工作站檢查已完成',
    cleaningStep4: '準備好使用新原料類型',
    confirmCleaningComplete: '是的，清潔完成',
    materialTypeMismatch: '原料類型不符',
    sessionUses: '此工作使用',
    cannotDetermineMaterialType: '無法確定原料類型',

    // Production Planning
    productionPlanning: '生產計劃',
    createManageSessions: '建立和管理生產工作',
    newProductionSession: '新增生產工作',
    createProductionSession: '建立生產工作',
    validationErrors: '驗證錯誤',

    // Multi-Station Mode
    stationAssignment: '工站分配',
    singleStation: '單一工站',
    multiStation: '多工站',
    multiStationMode: '多工站模式',
    multiStationModeDescription: '將原料分配到多個工站。每個工站將作為獨立的子工作運行。',
    materialAllocationStatus: '原料分配狀態',
    fullyAllocated: '已完全分配',
    unallocated: '未分配',
    addStation: '新增工站',
    materialAllocation: '原料分配',
    stationSubSessions: '工站子工作',
    stationsCount: '工站',
    addRawMaterialsFirst: '請先在上方新增原料，然後再配置工站分配',
    eachStationMustHaveMaterial: '每個工站必須至少分配一些原料',
    allMaterialMustBeAllocated: '所有原料重量必須分配到工站。請檢查分配總量。',
    selectStationForAllAllocations: '請為所有分配選擇工站',
    eachStationCanOnlyBeAssignedOnce: '每個工站只能分配一次',
    atLeastOneStationRequired: '多工站模式下必須分配至少一個工站',

    // Station Details Modal (uses keys from stations section)
    stationId: '工站編號',
    locationInformation: '位置資訊',
    locationName: '位置名稱',
    locationCode: '位置代碼',
    warehouseCode: '倉庫編號',
    configuration: '配置',
    stationType: '工站類型',
    notSet: '未設定',
    sessionStatus: '工作狀態',
    close: '關閉',

    // Camera Management (from earlier section)
    cameraManagement: '攝影機管理',
    configureCCTVCameras: '配置用於工站監控的CCTV攝影機',
    addCamera: '新增攝影機',
    camera: '攝影機',
    noCamerasConfigured: '尚未配置攝影機',
    addFirstCamera: '新增您的第一個攝影機以開始監控工作站',
    status: '狀態',
    position: '位置',
    resolution: '解析度',
    cameraAddedSuccessfully: '攝影機新增成功',
    failedToAddCamera: '新增攝影機失敗',
    cameraUpdatedSuccessfully: '攝影機更新成功',
    failedToUpdateCamera: '更新攝影機失敗',
    cameraDeletedSuccessfully: '攝影機刪除成功',
    failedToDeleteCamera: '刪除攝影機失敗',
    pleaseFillRequiredFields: '請填寫所有必填欄位',
    confirmDeleteCamera: '您確定要刪除此攝影機嗎？',
    editCamera: '編輯攝影機',
    addNewCamera: '新增攝影機',
    selectStation: '選擇工作站',
    cameraName: '攝影機名稱',
    cameraNamePlaceholder: '例如：工作站1 - 頂部',
    cameraURL: '攝影機URL',
    supportsStreamURLs: '支援 RTSP、HTTP、MJPEG 或 HLS 串流 URL',
    cameraType: '攝影機類型',
    positionPlaceholder: '例如：頂部、左側',
    notes: '備註',
    notesPlaceholder: '關於此攝影機的其他備註...',
    updateCamera: '更新攝影機',

    // Label Management
    labelManagement: '標籤管理',
    manageAndReprintLabels: '管理和重新列印已包裝箱的標籤',
    productionDate: '生產日期',
    selectSession: '選擇會話',
    selectSessionPlaceholder: '-- 選擇會話 --',
    noSessionsForDate: '此日期沒有找到會話',
    filterByStatus: '按狀態篩選',
    allBoxes: '所有箱子',
    readyBoxes: '已包裝箱子',
    shippedBoxes: '已發箱子',
    totalBoxes: '總箱數',
    boxesWithReprints: '重印箱數',
    boxNumber: '箱號',
    weight: '重量',
    packedBy: '包裝人員',
    labelStatus: '標籤狀態',
    lastPrinted: '最後列印',
    noActiveLabel: '無有效標籤',
    reprinted: '已重印',
    original: '原始',
    viewHistory: '查看歷史',
    reprintLabel: '重新列印標籤',
    noBoxesFound: '未找到所選會話和狀態的箱子。',
    labelPrintHistory: '標籤列印歷史',
    printNumber: '列印次數',
    printedAt: '列印時間',
    printedBy: '列印人員',
    discardedAt: '作廢時間',
    discardedBy: '作廢人員',
    discardReason: '作廢原因',
    noLabelHistory: '此箱子沒有標籤列印歷史。',
    reprintWarning: '這將標記當前標籤為作廢並列印新標籤。',
    reprintReason: '重印原因',
    selectReprintReason: '選擇原因...',
    reprintReasonPlaceholder: '請輸入重新列印標籤的原因...',
    confirmReprint: '確認重印',
    pleaseProvideReason: '請提供重印原因',
    labelReprintedSuccess: '標籤重印成功',
    failedToReprintLabel: '重印標籤失敗',

    // Printer Configuration
    labelPrinterConnected: '標籤打印機已連接',
    noLabelPrinter: '無標籤打印機',
    directPrintingEnabled: '直接打印已啟用',
    willUseBrowserDialog: '將使用瀏覽器打印對話框',
    connectPrinter: '連接打印機',
    detecting: '檢測中...',
    printDirect: '直接打印',

    // Station Management (uses keys from stations section)
    stationManagement: '工作站管理',
    manageStations: '管理所有地點的生產工作站',
    bulkAssignProducts: '批量指派產品',
    totalStationsCount: '總工作站數',
    warehouse: '倉庫',
    allStatuses: '所有狀態',
    idle: '閒置',
    idleStations: '閒置工作站',
    unassignedSessions: '未分配的工作',
    noStationAssigned: '未分配工站',
    materialOnHold: '材料待審核',
    cannotDeactivate: '無法停用有進行中工作的工作站。產品：',
    pleaseCompleteSession: '請先完成或取消會話',
    deactivate: '停用',
    activate: '啟用',

    // Station Enable/Disable
    stationEnabled: '工作站已啟用',
    stationDisabled: '工作站已停用',
    failedToToggleStation: '切換工作站狀態失敗',
    cannotDisableWithActiveSession: '無法停用有進行中會話的工作站',
    clickToEnable: '點擊啟用工作站',
    clickToDisable: '點擊停用工作站',
    disabled: '已停用',
    stationsEnabled: '個工作站已啟用',
    assign: '指派',

    // Schedule View
    addNewSchedule: '新增生產工單',
    byWeight: '按重量',
    byBoxes: '按箱數',
    sessionCode: '生產代碼',
    scheduleDate: '日期',
    transferDate: '轉移日期',
    dateRangeHint: '日期可設為今天至未來三週內',
    manpowerForDate: '當日人力安排',
    operators: '切割員',
    packers: '包裝員',
    stations: '工作站',
    noManpowerScheduled: '此日期無人力安排',
    noManpowerWarning: '等待主管安排操作員',
    sourceWarehouse: '來源地點',
    sourceWarehouseHint: '選擇後將自動建立入庫調撥單',
    sourceWarehouseTooltip: '將自動建立一筆入庫轉移',
    sourceWarehouseRequiredHint: '將自動建立入庫調撥單',
    noInboundTransferNeeded: '此生產排程不需要入庫調撥，廠內原料庫存足以涵蓋所需數量。',
    transferBackDestination: '轉回目的地',
    transferBackDestinationHint: '出貨轉單將在排定的生產日自動建立',
    transferBackDestinations: '轉回目的地',
    addDestination: '新增目的地',
    selectDestination: '選擇…',
    duplicateDestination: '每個目的地每場次只能選一次。',
    transferBackDestinationsHint: '每個目的地會建立一筆出庫轉移',
    casesUnit: '箱',
    scheduleItemNumber: '成品',
    scheduleProductName: '產品名稱',
    packing: '包裝',
    cases: '成品箱數',
    targetBoxes: '目標箱數',
    targetCases: '目標箱數',
    estimatedLbs: '預估磅數',
    material: '原料料號',
    primaryMaterial: '主要產品',
    selectedMaterials: '已選原料',
    laborFactor: '人力',
    selectMaterialForLaborFactor: '選擇原料以查看勞動係數',
    labourEstimatedOutput: '預估產量',
    labourEstimatedOutputCases: '≈ {{count}} 箱',
    labourMaxForDay: '本日最大產量',
    labourWithAllowance: '含寬放 (−{{pct}}%)',
    labourMaxApplyHint: '點擊以填入目標箱數',
    labourRemainder: '剩餘量',
    labourWorkers: '工人數',
    labourSessions: '班次',
    labourDuration: '時長（小時）',
    labourBasedOnInput: '基於 {{weight}} 磅投料',
    labourNoFactor: '無勞動係數',
    labourYieldOnlyEstimate: '僅限良率',
    meanProduction: '平均產量 #',
    scheduleBrand: '品牌',
    multipleBrands: '多個品牌',
    scheduleLocation: '位置',
    noScheduledSessions: '此日期無排定工單',

    // 多原料表單
    lbsInput: '重量 (磅)',
    unitWeight: '單位重量',
    estOutput: '預估產出磅數',
    estInput: '預估投入磅數',
    estUsableMaterial: '預估可用 (磅)',
    estimatedBoxes: '預估箱數',
    byproducts: '次級產品 / 副產品',
    estCases: '原料箱數',
    caseWeight: '箱重',
    requiredWeight: '所需重量 (磅)',
    addMaterial: '新增原料',
    exceedsStock: '超過可用庫存',
    partialTransferNeeded: '需要調撥',
    yieldNotConfigured: '無收率',
    totalLbs: '總重量',
    totalCases: '總箱數',
    totalInputWeight: '總投入重量',
    totalOutputWeight: '總產出重量',
    totalEstUsable: '預估可用',
    availableStock: '可用 HTE',
    icsBalance: 'VB6 Balance',
    frozen: '冷凍',
    fresh: '新鮮',
    availableAtHte: '可用 (@HTE)',
    insufficientSourceStock: '庫存不足於',
    onlyHas: '僅有',
    needed: '需要',
    onHold: '待審核',
    materialsOnHold: '已核准原料（待用）',
    materialsInHTE: '可用原料（在 HTE）',
    totalAvailable: '總可用量',
    totalAvailableAtHte: '總可用量 (@HTE)',
    includingOnHold: '含待用原料',
    onHoldApprovedBadge: '已核准',
    selectProductError: '請選擇產品',
    pastDateError: '排程日期不能是過去的日期',
    weekendWarningProduction: '所選生產日期為{{day}}',
    weekendWarningTransfer: '所選轉移日期為{{day}}',
    selectMaterialError: '請至少添加一種有重量的原料',
    exceedsStockError: '一個或多個原料超過可用庫存',

    // 內聯原料關聯
    otherProducts: '其他產品（未關聯原料）',
    noMaterials: '新增',
    noMaterialsLinked: '此產品尚未關聯原料',
    addMaterialsPrompt: '搜索並添加原料以繼續建立生產排程。',
    searchRawMaterials: '按名稱或編號搜索原料...',
    materialLinked: '已關聯',
    materialLinkError: '關聯原料失敗',
    materialLinkSuccess: '原料關聯成功',
    materialUnlinked: '已移除原料',
    setPreference: '設定偏好順序',

    // 原料排序選項
    sortPreference: '優先順序',
    sortYieldHigh: '產出率 ↓',
    sortYieldLow: '產出率 ↑',
    sortLaborHigh: '人工 ↓',
    sortLaborLow: '人工 ↑',
    sortAvailabilityHigh: '庫存 ↓',
    sortAvailabilityLow: '庫存 ↑',

    // 導出
    exportToExcel: '導出至Excel',
    exportSessions: '導出工單',
    selectDateRange: '選擇日期範圍',
    startDate: '開始日期',
    endDate: '結束日期',
    sessionsToExport: '要導出的工單',
    noSessionsInRange: '此日期範圍內沒有工單',
    exporting: '導出中...',

    // 編輯/刪除工單
    editSession: '編輯工單',
    editProductionSession: '編輯生產工單',
    sessionUpdatedSuccess: '工單更新成功',
    failedToUpdateSession: '工單更新失敗',
    confirmCancelSession: '取消工單？',
    cancelSessionWarning: '此操作無法撤銷。工單將被標記為已取消。',
    forceCancelActiveSession: '強制取消進行中的工單？',
    forceCancelWarning: '此工單目前正在進行中。取消將釋放工作站並解除操作員分配。任何未保存的進度將會丟失。',
    sessionCancelledSuccess: '工單取消成功',
    failedToCancelSession: '工單取消失敗',

    // 未完成工單警示
    incompleteSessionsAlert: '往日未完成的工單',
    incompleteSessionsCount: '個往日未完成的工單需要處理',
    incompleteSessionsDescription: '以下工單尚未完成，可能需要處理：',
    scheduledFor: '排定日期',
    viewInPlanning: '查看生產計劃',
    dismissIncompleteAlert: '關閉',

    // 待審核警示
    pendingApprovalsAlert: '待審核項目',

    // 儀表板 KPI 子卡片標籤
    todaysSessions: '今日工單',
    planned: '已提交',
    activeLabel: '進行中',
    completedLabel: '已完成',
    avgYield: '平均產出率',
    enabledLabel: '已啟用',
    stationOverview: '工站總覽',

    // 生產進度概覽
    productionProgressOverview: '生產進度概覽',
    overall: '總體',
    noSessionsToday: '今日無排定的生產工單',
    lbs: 'lbs',
  },

  // 主管行動版
  mobileSupervisor: {
    title: '主管',
    subtitle: '行動儀表板',
    stationOverview: '工站總覽',
    stationOverviewDesc: '查看所有工站狀態',
    sessionManagement: '工單管理',
    sessionManagementDesc: '管理生產工單',
    productionPlanning: '新增工單',
    productionPlanningDesc: '建立生產工單',
    transferVerification: '收貨',
    transferVerificationDesc: '驗證箱子移轉',
    receiveVerify: '調撥單',
    receiveVerifyDesc: '接收進貨調撥',
    transfers: '調撥',
    transfersDesc: '接收與查看調撥',
    receive: '接收',
    receiveDesc: '接收進貨調撥',
    transferOption: '發送',
    transferOptionDesc: '退回倉庫',
    allTransfers: '所有調撥',
    allTransfersDesc: '查看所有調撥單',
    inventoryDesc: '查看材料與庫存',
    // 掃描選項彈窗
    scanOptions: '您要掃描什麼？',
    labelLookup: '標籤查詢',
    labelLookupDesc: '掃描箱子標籤查看詳情',
    scanStation: '掃描工站',
    scanStationDesc: '掃描工站 QR 碼查看狀態',
    endOfDaySummary: '每日總結',
    endOfDaySummaryDesc: '生產統計',
    overrideHistory: '覆寫記錄',
    overrideHistoryDesc: '查看過去的覆寫',
    // 覆寫類型
    manualWeight: '手動重量',
    labelReprint: '標籤重印',
    sessionCompletion: '工單完成',
    stationManagement: '工站設定',
    stationManagementDesc: '啟用/停用工站',
    scanBoxBarcode: '掃描箱子條碼',
    scanBoxHint: '將掃描器對準箱子上的 GS1 條碼',
    boxFound: '已找到箱子',
    boxNotFound: '找不到箱子',
    reprintLabel: '重印標籤',
    reprintingLabel: '正在重印標籤...',
    labelReprinted: '標籤已發送到印表機',
    scanAnother: '掃描另一個',
    scanToVerify: '掃描箱子以驗證',
    scanTransferBoxHint: '掃描箱子條碼以驗證移轉',
    pendingTransfers: '待處理',
    verifiedThisSession: '已驗證',
    transferVerified: '移轉已驗證',
    transferRejected: '移轉已拒絕',
    boxesVerified: '本次已驗證的箱子',
    verify: '驗證',
    reject: '拒絕',
    from: '從',
    to: '到',
    stationEnabled: '工站已啟用',
    stationDisabled: '工站已停用',
    cannotDisableActiveStation: '工單進行中無法停用',
    selectProduct: '選擇產品',
    selectStation: '選擇工站',
    selectMaterial: '選擇原料',
    confirmSession: '確認工單',
    noAvailableStations: '沒有可用的工站',
    createSession: '建立工單',
    sessionCreated: '工單已建立',
  },

  // 生產監控
  productionMonitor: {
    title: '生產監控',
    scheduleView: '排程檢視',
    sessionManagement: '工單管理',
    activeSessions: '進行中的工單',
    operatorsWorking: '工作中的操作員',
    todaysOutput: '今日產出',
    sessionsAtRisk: '有風險的工單',
    activeSessionsTable: '進行中的工單',
    autoRefreshNote: '每30秒自動更新',
    noActiveSessions: '目前沒有進行中的工單',
    session: '工單',
    product: '產品',
    operator: '操作員',
    station: '工作站',
    elapsed: '已用時間',
    progress: '進度',
    output: '產出',
    pace: '速率',
    status: '狀態',
    estCompletion: '預計完成',
    projOutput: '預計產出',
    projRemaining: '預計剩餘',
    actualOutput: '實際產出',
    remaining: '剩餘',
    onTrack: '正常',
    atRisk: '有風險',
    behind: '落後',
    subSessions: '子工單',
    multiple: '多個',
    columns: '欄位',
    completedSessions: '已完成工單',
    cancelledSessions: '已取消工單',
    reason: '原因',
  },

  // 管理頁面
  admin: {
    // 用戶頁面
    users: '用戶',
    manageUserAccounts: '管理用戶帳戶和權限',
    addUser: '新增用戶',
    searchUsers: '搜索用戶...',
    allRoles: '所有角色',
    admin: '管理員',
    supervisor: '主管',
    manager: '經理',
    operator: '操作員',
    warehouse: '倉庫',
    route: '路線',
    user: '用戶',
    role: '角色',
    lastLogin: '最後登錄',
    active: '啟用',
    inactive: '停用',
    editUser: '編輯用戶',
    deactivateUser: '停用用戶',
    activateUser: '啟用用戶',
    deleteUser: '刪除用戶',
    noUsersFound: '找不到用戶',
    tryAdjustingSearch: '請調整搜索條件',
    getStartedCreatingUser: '開始創建新用戶',
    totalUsers: '總用戶數',
    activeUsers: '啟用用戶',
    admins: '管理員',
    confirmDeleteUser: '確定要刪除',
    actionCannotBeUndone: '此操作無法撤銷',
    userDeletedSuccess: '用戶刪除成功',
    failedToDeleteUser: '刪除用戶失敗',
    userStatusUpdated: '用戶狀態更新成功',
    failedToUpdateUserStatus: '更新用戶狀態失敗',
    failedToLoadUsers: '載入用戶失敗',
    pleaseRefresh: '請刷新後重試',

    // 設置頁面
    systemSettings: '系統設置',
    configureSystemPreferences: '配置系統偏好和選項',
    reset: '重置',
    saveChanges: '保存更改',
    saving: '保存中...',
    general: '一般',
    notifications: '通知',
    security: '安全',
    production: '生產',
    system: '系統',
    generalSettings: '一般設置',
    companyName: '公司名稱',
    timezone: '時區',
    dateFormat: '日期格式',
    currency: '貨幣',
    language: '語言',
    notificationPreferences: '通知偏好',
    emailNotifications: '電子郵件通知',
    emailNotificationsDesc: '通過電子郵件接收重要更新',
    lowStockAlerts: '低庫存警報',
    lowStockAlertsDesc: '庫存不足時收到通知',
    stationOfflineAlerts: '工位離線警報',
    stationOfflineAlertsDesc: '生產工位離線時發出警報',
    productionAlerts: '生產警報',
    productionAlertsDesc: '生產里程碑通知',
    dailyReports: '每日報告',
    dailyReportsDesc: '接收自動化每日生產報告',
    securitySettings: '安全設置',
    sessionTimeout: '會話超時（分鐘）',
    sessionTimeoutDesc: '用戶將在此閒置時間後自動登出',
    passwordMinLength: '密碼最小長度',
    maxLoginAttempts: '最大登錄嘗試次數',
    maxLoginAttemptsDesc: '失敗嘗試此次數後帳戶將被鎖定',
    requireStrongPassword: '要求強密碼',
    requireStrongPasswordDesc: '強制使用大寫、小寫、數字和特殊字符',
    enableTwoFactor: '啟用雙因素認證',
    enableTwoFactorDesc: '所有用戶需要額外驗證',
    labelPrinting: '標籤列印',
    productionSettings: '生產設置',
    defaultTargetWeight: '默認目標重量（公斤）',
    autoAssignOperators: '自動分配操作員',
    autoAssignOperatorsDesc: '自動將可用操作員分配到工位',
    allowManualWeightEntry: '允許手動輸入重量',
    allowManualWeightEntryDesc: '允許操作員手動輸入重量',
    simulatePrinter: '模擬印表機',
    simulatePrinterDesc: '開啟時，不會將標籤傳送至實體印表機',
    simulatePrinterPrintSkipped: '模擬模式：列印已跳過 — 顯示標籤預覽',
    labelCopies: '標籤份數',
    labelCopiesDesc: '每箱列印的標籤份數',
    printerSubnet: '印表機網路子網段',
    printerSubnetDesc: '網路的前 3 個八位元（例如 192.168.1）',
    printServiceUrl: '列印服務網址',
    printServiceUrlDesc: '工廠列印服務的 HTTPS 網址（例如 https://192.168.1.100:3010）。本機開發時請留空。',
    registeredPrinters: '已註冊印表機',
    registeredPrintersDesc: '在此註冊印表機並指派工作站。變更會反映在工作站管理中。',
    addPrinter: '新增印表機',
    printerName: '印表機名稱',
    printerNamePlaceholder: '例如 printer_1',
    printerMacValue: 'MAC 位址',
    noPrintersRegistered: '尚未註冊任何印表機',
    printerAdded: '印表機註冊成功',
    printerDeleted: '印表機已移除',
    printerStaticIp: '固定 IP（可選）',
    printerStaticIpPlaceholder: '例如 172.168.36.179',
    printerIpSaved: '印表機 IP 已儲存',
    printerIpCleared: '印表機 IP 已移除',
    invalidIpAddress: '無效的 IP 位址格式',
    confirmDeletePrinter: '移除此印表機？',
    assignStationToPrinter: '指派工作站...',
    noStationsAvailable: '沒有可用的工作站',
    assignedElsewhere: '已指派給其他印表機',
    supervisorOffice: '主管辦公室',
    noStationAssigned: '未指派工作站',
    printerNickname: '名稱',
    printerIpAddress: 'IP 位址',
    printerPort: '連接埠',
    printerStation: '工作站',
    selectStation: '選擇工作站...',
    selectPrinter: '選擇印表機...',
    showMac: '顯示 MAC',
    hideMac: '隱藏 MAC',
    noIpSet: '未設定 IP',
    printerTestPanel: '測試列印',
    printerTestPanelDesc: '發送測試標籤以驗證印表機連線。',
    printTestLabel: '列印測試標籤',
    // Batch Label Print
    batchLabelPrint: '批量標籤列印',
    batchLabelPrintDesc: '無需啟動生產工單，即可為成品批量預印標籤。',
    batchProduct: '產品',
    batchSelectProduct: '選擇產品...',
    batchNumberOfBoxes: '箱數',
    batchDateTime: '日期和時間',
    batchPrinter: '印表機',
    batchTotalLabels: '標籤總數',
    batchBoxes: '箱',
    batchCopies: '份',
    batchPrintButton: '列印標籤',
    batchPrinting: '列印中...',
    batchPrintingBox: '正在列印第',
    batchPrintSuccess: '批量列印完成',
    batchPrintSimulated: '批量列印模擬完成',
    batchPrintFailed: '批量列印失敗',
    batchPrintLabels: '張標籤',
    printerNotConfigured: '此工作站未分配印表機。請在設定→標籤列印中分配印表機。',
    stationServiceDown: '無法連接工作站服務以查找印表機。請重試。',
    arpLookupFailed: '在網路上找不到印表機。請確保印表機已開機並已連接。',

    advancedSettings: '進階設定',

    // Scale Management (Settings → Scales tab)
    scales: '秤',
    registeredScales: '已註冊秤',
    registeredScalesDesc: '註冊網路秤並將其分配到工作站。每個工作站一台秤。',
    addScale: '新增秤',
    scaleNickname: '名稱',
    scaleNicknamePlaceholder: '例如 主秤',
    scaleIpAddress: 'IP 地址',
    scaleIpPlaceholder: '172.168.110.227',
    scalePort: '端口',
    scalePortPlaceholder: '1701',
    scaleStation: '工作站',
    noScalesRegistered: '尚未註冊任何秤',
    scaleAdded: '秤註冊成功',
    scaleDeleted: '秤已移除',
    confirmDeleteScale: '移除此秤？',
    scaleTestConnection: '測試連接',
    scaleTestSuccess: '連接成功',
    scaleTestFailed: '連接失敗',
    scaleTestPanel: '秤測試',
    scaleTestPanelDesc: '測試秤的連接性並查看即時重量讀數。',
    selectScale: '選擇秤...',
    scaleDeviceInfo: '設備資訊',
    scaleLiveWeight: '即時重量',
    scaleRawLog: '原始日誌',
    scaleNoMessages: '尚無訊息',
    scaleTesting: '測試中...',
    scaleReadMode: '讀取模式',
    scaleModeContinuous: '持續',
    scaleModeOnPrint: '按列印',
    scaleModeContinuousDesc: '每500毫秒讀取重量',
    scaleModeOnPrintDesc: '僅在按下秤上的列印按鈕時讀取',
    scaleReconnect: '重新連接',
    scaleReconnectStarted: '已開始重新連接',
    scaleStableWeight: '穩定重量 (S)',

    requireQualityCheck: '需要質量檢查',
    requireQualityCheckDesc: '完成前必須進行質量驗證',
    dataRetentionDays: '數據保留（天）',
    dataRetentionDaysDesc: '歷史數據歸檔前的保留時間',
    backupFrequency: '備份頻率',
    daily: '每日',
    weekly: '每週',
    monthly: '每月',
    maintenanceMode: '維護模式',
    maintenanceModeDesc: '禁用系統訪問進行維護',
    debugMode: '調試模式',
    debugModeDesc: '啟用詳細日誌以進行故障排除',
    automaticBackups: '自動備份',
    automaticBackupsDesc: '啟用自動數據庫備份',
    warning: '警告',
    settingsWarning: '更改系統設置可能會影響所有用戶。請確保在保存前了解影響。',
    unsavedChanges: '您有未保存的更改',
    settingsSavedSuccess: '設置保存成功',
    failedToSaveSettings: '保存設置失敗',

    // 位置頁面
    locationsAndWarehouses: '位置和倉庫',
    manageProductionLocations: '管理生產位置和連接的倉庫',
    searchLocations: '搜索位置、地址或倉庫...',
    allStatus: '所有狀態',
    capacity: '容量',
    noLocationsFound: '找不到位置',
    getStartedCreatingLocation: '開始創建新位置',
    totalLocations: '總位置數',
    activeLocations: '啟用位置',
    totalCapacity: '總容量',
    highCapacity: '高容量',
    confirmDeleteLocation: '確定要刪除位置',
    locationCreatedSuccess: '位置創建成功',
    failedToCreateLocation: '創建位置失敗',
    locationUpdatedSuccess: '位置更新成功',
    failedToUpdateLocation: '更新位置失敗',
    locationDeletedSuccess: '位置刪除成功',
    failedToDeleteLocation: '刪除位置失敗',
    locationStatusUpdated: '位置狀態已更新',
    failedToUpdateStatus: '更新狀態失敗',

    // Feature Flags
    featureFlags: '功能設定',
    featureFlagsDesc: '為所有用戶全域啟用或停用功能。',
    materialTypeRestriction: '原料類型限制',
    materialTypeRestrictionDesc: '限制工作站只能處理特定原料類型（雞肉、牛肉、豬肉、羊肉等）',
    scannerIntegration: '掃描器整合',
    scannerIntegrationDesc: '啟用條碼掃描器功能進行掃描驗證',
    saveAndReload: '儲存並重新載入',
    featureFlagsNote: '功能設定儲存在您的瀏覽器中。更改將重新載入頁面以生效。',
    featureFlagsNoteGlobal: '功能設定儲存在資料庫中，適用於所有用戶。更改立即生效。',
    featureFlagsSaved: '功能設定已成功儲存',
    databaseToggles: '資料庫開關',
    databaseTogglesDesc: '這些設定儲存在資料庫中，對所有用戶立即生效。',
    enableInputOutputEditing: '投入/產出對應編輯',
    enableInputOutputEditingDesc: '允許主管在投入/產出對應標籤中新增原物料連結',
    requirePostPrintScan: '列印後掃描工牌與標籤',
    requirePostPrintScanDesc: '列印標籤後，要求包裝員掃描工牌和箱標籤才能記錄生產',

    // 生產標籤（管理員）
    productionTab: '生產',
    yieldVarianceThresholds: '產出率差異閾值',
    yieldVarianceThresholdsDesc: '配置系統中用於產出率監控的差異閾值。',
    yieldThresholdLabel: '產出率差異閾值',
    yieldThresholdDesc: '產出率差異超過此值時會觸發警告、需要主管審批，並在報告中標記子工段。',
    yieldThresholdsSaved: '產出率閾值已成功儲存',
    yieldThresholdsSaveFailed: '儲存產出率閾值失敗',

    // 重量模式和容差設定
    defaultWeightMode: '預設重量模式',
    defaultWeightModeDesc: '未設定工段級別覆蓋時，包裝員視圖的全域預設重量模式。',
    weightModeFixed: '固定',
    weightModeCatch: '隨機',
    weightModeScale: '磅秤',
    weightTolerance: '重量容差',
    weightToleranceDesc: '超過目標單位重量的最大可接受重量（磅）。',
    weightSettingsSaved: '重量設定已成功儲存',
    weightSettingsSaveFailed: '儲存重量設定失敗',
    autoTareTitle: '自動去皮（磅秤模式）',
    autoTareDesc: '自動從磅秤讀數中扣除包裝重量。僅在重量模式為磅秤時適用。',
    bagTare: '袋子去皮',
    bagTareDesc: '子單位包裝時需扣除的袋子包裝重量。',
    caseTare: '箱子去皮',
    caseTareDesc: '最終裝箱時需扣除的箱子/紙箱包裝重量。',
    tareGross: '毛重',
    tareTare: '皮重',
    tareNet: '淨重',

    // HTE 庫存標籤（管理員）
    hteStock: {
      title: 'HTE 庫存',
      lotsTitle: '批次庫存',
      itemNumber: '品號',
      itemName: '品名',
      currentAmount: '當前數量 (lbs)',
      receivedDate: '收貨日',
      bufferTitle: '副產品市場緩衝',
      byproduct: '副產品',
      reservedWeight: '保留重量 (lbs)',
      confirmPassword: '確認變更',
      password: '密碼',
      reason: '原因',
      reasonPlaceholder: '為什麼需要此變更？',
      updateConfirmMsg: '請輸入原因和密碼以確認此更新。',
      deleteConfirmMsg: '請輸入原因和密碼以確認此刪除。',
      lotUpdated: '批次數量已更新',
      bufferUpdated: '緩衝重量已更新',
      bufferDeleted: '緩衝列已刪除',
      updateFailed: '更新失敗',
      deleteFailed: '刪除失敗',
      invalidCredentials: '無效的憑證',
      invalidValue: '值必須是 >= 0 的數字',
    },
  },

  // 箱子確認（雙重掃描）
  boxConfirm: {
    scanBadgePrompt: '掃描您的員工證進行確認',
    scanLabelPrompt: '現在掃描箱子標籤',
    confirmed: '箱子已確認',
    badgeMismatch: '員工證與指定包裝員不符',
    labelNotFound: '找不到箱子標籤',
    step1: '步驟1：掃描您的員工證',
    step2: '步驟2：掃描箱子標籤',
    waitingForBadge: '等待員工證掃描...',
    waitingForLabel: '等待標籤掃描...',
    verifying: '驗證中...',
    success: '箱子已確認！',
    badgeScanned: '員工證已掃描',
    scanBadgeFirst: '請先掃描您的員工證',
    alreadyScannedBadge: '員工證已掃描。請掃描箱子標籤。',
    skipScan: '跳過掃描',
    manualConfirmHint: '如果掃描器不工作請使用此選項',
    helpText: '掃描您的員工證，然後掃描貼在箱子上的標籤進行確認',
  },

  // 原料
  material: {
    initialWeight: '原料重量',
    rawMaterial: '原料',
    brand: '品牌',
    yieldFactor: '出成率',
  },

  // 打卡
  clockIn: {
    title: '打卡',
    scanStation: '掃描工作站條碼',
    scanStationHint: '將掃描器對準工作站條碼',
    scanBadge: '掃描您的員工證',
    scanBadgeHint: '將掃描器對準您的員工證',
    selectRole: '選擇您的角色',
    operator: '操作員',
    packer: '包裝員',
    welcome: '歡迎',
    currentAssignments: '目前分配',
    noActiveSession: '此工作站沒有進行中的會話',
    employeeNotFound: '找不到員工',
    employeeDeactivated: '員工已停用',
    stationNotFound: '找不到工作站',
    alreadyAssigned: '您已被分配為 {role}',
    relieveConfirm: '接替 {name} 的 {role} 職位？',
    relieveDescription: '{name} 從 {time} 開始工作',
    transferConfirm: '轉換工作站？',
    transfer: '轉換',
    clockedIn: '掃描成功',
    clockingInAsPacker: '正在以包裝員身份登入...',
    redirecting: '正在跳轉到生產頁面...',
    scanDifferentStation: '掃描其他工作站',
    skipToProduction: '跳過到生產 →',
    clockOut: '掃描登出',
    clockOutConfirm: '從 {station} 掃描登出？',
    clockedOut: '掃描登出成功',
    orEnterManually: '或手動輸入：',
  },

  // 行動裝置介面
  mobile: {
    // 掃描登出
    scanOut: '掃描登出',

    // 打卡
    scanStation: '掃描工作站',
    scanBadge: '掃描員工證',
    selectRole: '選擇角色',
    confirmRelief: '確認接班',
    success: '成功',
    scanStationBarcode: '掃描工作站條碼',
    scanStationHint: '將掃描器對準工作站條碼',
    scanYourBadge: '掃描您的員工證',
    scanBadgePlaceholder: '掃描或輸入員工證...',
    scanBadgeAbove: '掃描您的員工證',
    orEnterManually: '或手動輸入：',
    noActiveSession: '此工作站沒有進行中的會話',
    sessionCompleted: '此工作階段已完成',
    sessionCancelled: '此工作階段已取消',
    materialsNotReceived: '子工作階段 {subSessionNumber} 的原物料尚未接收。生產無法開始。',
    awaitingAssignment: '子工作階段 {subSessionNumber} 的轉移已接收，但子工作階段正在等待操作員/包裝員指派。',
    scheduledFuture: '子工作階段 {subSessionNumber} 排定於未來日期，目前無法開始。',
    currentAssignments: '目前值班人員',
    operator: '操作員',
    packer: '包裝員',
    selectYourRole: '選擇您的角色',
    relieveWorker: '接替值班？',
    currentlyWorkingAs: '目前正在擔任',
    yesRelieve: '是，交接他們',
    clockedIn: '已打卡！',

    // 操作員介面
    operatorView: '操作員介面',
    confirmBackToStation: '確定返回掃描站點？',
    clockOut: '掃描登出',
    clockedOut: '掃描登出成功',
    clockedOutFromAnotherDevice: '您已從另一台設備登出',
    loggedInFromAnotherDevice: '您已從另一台設備登入',
    youHaveBeenRelieved: '您已被其他員工交接',
    sessionProgress: '會話進度',
    materialWeight: '投入原料',
    remaining: '預估剩餘產出',
    pace: '速度',
    instructions: '作業說明',
    operatorInstructions: '監控生產線並確保品質標準。與包裝員協調箱子重量。',
    qualityReminder: '檢查異物並確保密封前包裝正確。',

    // 包裝員介面
    packerView: '包裝員介面',
    boxes: '箱',
    weightWindow: '重量範圍',
    enterWeight: '輸入箱子重量',
    weightValid: '重量在範圍內',
    weightTooLow: '重量太輕',
    weightTooHigh: '重量太重',
    printLabel: '列印標籤',
    packSubUnit: '包裝子單位',
    subUnit: '子單位',
    packed: '已包裝',
    subUnitsPacked: '子單位已包裝',
    nowPackTheBox: '現在包裝箱子',
    labelPrinted: '標籤已列印！',
    printerUnavailableBoxCounted: '印表機不可用 — 已計箱',
    printerUnavailableCannotProceed: '印表機不可用 — 無法列印標籤。請檢查印表機連接。',
    confirmLabel: '確認標籤已貼上',
    scanToConfirm: '掃描員工證然後掃描標籤以確認',
    step1ScanBadge: '1. 掃描您的員工證',
    step2ScanLabel: '2. 掃描箱子標籤',
    waiting: '等待中...',
    verifying: '驗證中...',
    scanBadgeFirst: '請先掃描員工證',
    badgeScanned: '員工證已掃描',
    scanLabelNotBadge: '請掃描箱子標籤，不是員工證',
    boxConfirmed: '箱子已確認！',
    boxNumber: '箱子',
    scanBadgeForOptions: '掃描您的員工證以查看選項',
    scanStationForOptions: '先掃描工作站，再掃描員工證以查看選項',
    nowScanBadge: '現在掃描您的員工證',
    stationScanned: '工作站已掃描 - 現在掃描您的員工證',
    wrongStation: '工作站錯誤 - 請掃描正確的工作站',
    wrongBadge: '員工證錯誤 - 請掃描您的員工證',
    stationBarcode: '工作站條碼...',
    badgeNumber: '員工證號碼...',
    scanStationFirst: '請先掃描工作站',
    whatWouldYouLikeToDo: '您想做什麼？',
    backToPacker: '返回包裝',
    takeBreak: '休息',
    pausing: '暫停中...',
    breakStarted: '休息開始',
    differentBadge: '掃描到不同的員工證',
    supervisorOverrideActivated: '主管覆蓋已啟動',
    supervisorNoSession: '找不到進行中的工作階段',
    supervisorSessionError: '無法載入工作階段資料',
    supervisorBadgeError: '無法驗證員工證',
    noOperatorAssigned: '此工作階段尚未指派操作員',
    supervisor: '主管',
    supervisorOverride: '主管覆蓋',
    scanSupervisorBadgeToContinue: '掃描主管工牌以繼續',
    notASupervisor: '此工牌不屬於主管',
    badgeVerificationFailed: '工牌驗證失敗',
    labelReprintsManualWeight: '標籤重印、手動重量等',
    clockInAsWorker: '以員工身份打卡',
    workAsOperatorPacker: '以操作員或包裝員身份工作',
    verifyingBadge: '正在驗證員工證...',
    wrongPackerBadge: '員工證錯誤 - 只有登入的包裝員可以確認',
    resumingPendingBox: '恢復上一箱 - 掃描員工證以確認',
    previousBoxCancelled: '之前未確認的箱子已作廢',
    pendingLabelVoided: '待確認標籤已被主管作廢',
    boxCancelledCannotConfirm: '此箱子已作廢，無法確認',
    packingInstructions: '包裝說明',
    productionDetails: '生產詳情',
    itemNumber: '品號',
    englishName: '英文名稱',
    chineseName: '中文名稱',
    rawMaterial: '原料',
    packingSpec: '包裝規格',
    session: '工作階段',
    progress: '進度',
    weightPerBox: '每箱重量',
    expectedBoxes: '預計箱數',
    // 目標達成
    targetReached: '目標達成！',
    targetReachedMessage: '您已完成本次作業的所有目標箱數。',
    continuePacking: '繼續包裝',
    completeSession: '完成作業',
    finish: '結束',
    // 作業已完成（由主管標記）
    sessionCompletedBySupervisor: '作業已完成',
    sessionCompletedMessage: '此作業已被主管標記為完成。您無法再為此作業包裝箱子。',
    returnToClockIn: '返回掃描站點',
    // 提前完成（從徽章選單結束作業）
    endSession: '結束作業',
    earlyCompletionWarning: '提前結束作業',
    earlyCompletionWarningDesc: '進度未達100% - 作業將標記為覆蓋完成',
    earlyCompletionReason: '提前完成原因',
    selectReason: '選擇原因...',
    selectEarlyCompletionReason: '請選擇提前完成的原因',
    selectReasonFirst: '掃描前請先選擇原因',
    reasonShiftEnded: '班次結束',
    reasonMaterialShortage: '材料短缺',
    reasonEquipmentIssue: '設備問題',
    reasonOther: '其他',
    // 廢棄物追蹤精靈
    wasteTracking: '廢棄物追蹤',
    disposableWaste: '可棄廢料',
    disposableDesc: '垃圾，不可回收材料',
    humanError: '人為錯誤',
    humanErrorDesc: '不計入廢棄物',
    trackingOnly: '僅追蹤',
    returnsToInventory: '歸還庫存',
    productionRemainder: '生產剩餘',
    notWaste: '非廢棄物 - 歸還批次',
    byProduct: '副產品',
    byProductDesc: '可銷售或可再利用的副產品',
    byProductMarketable: '可銷售',
    byProductMarketableDesc: '可出售',
    byProductProduction: '用於生產',
    byProductProductionDesc: '重複使用於生產',
    thisSession: '本次作業',
    carryForward: '結轉',
    fromPriorSessions: '來自先前作業',
    bufferTotal: '緩衝區總計',
    readyCases: '準備好的箱數',
    reserve: '保留',
    addByproductEntry: '新增副產品',
    removeEntry: '移除',
    remainderNotIntact: '剩餘 - 非完整',
    remainderNotIntactDesc: '已開封或部分原料',
    finishProductNotIntact: '成品 - 非完整',
    finishProductNotIntactDesc: '未滿一箱的成品剩餘',
    intactBoxes: '剩餘 - 完整',
    intactBoxesDesc: '密封原料箱歸還批次',
    scanIntactBox: '掃描完整箱條碼',
    boxesScanned: '已掃描箱數',
    totalWeight: '總磅數',
    removeBox: '移除',
    selectMaterial: '選擇材料',
    selectByproduct: '選擇副產品',
    noLinkedByproducts: '無關聯副產品',
    noByproductMappings: '此子工作階段所使用的原料沒有關聯的副產品',
    enterWeightManually: '手動輸入重量',
    manualAddCase: '手動新增箱',
    manualEntry: '手動輸入',
    scanBoxNotBadge: '請掃描箱子條碼，而非工牌',
    invalidBarcode: '無效條碼 - 無法提取重量',
    boxAlreadyScanned: '此箱已被掃描',
    exceedsAllocatedWeight: '無法掃描：總量將超過分配重量',
    gtinMismatch: '條碼與分配的原材料不符',
    caseWeightMustBePositive: '箱重必須大於 0',
    caseWeightAboveMax: '箱重超過允許上限 {max} 磅',
    caseWeightOutOfRange: '箱重必須介於 {min} 至 {max} 磅之間',
    // 廢棄物摘要
    waterLiquid: '水分/液體損失',
    waterLiquidAuto: '自動計算',
    wasteSummary: '廢棄物摘要',
    yieldRate: '產出率',
    initialMaterial: '初始材料',
    totalOutput: '總產出',
    lbsCarryover: '磅結轉',
    carryover: '結轉',
    lbsFromSession: '磅來自作業',
    submitWaste: '提交',
    submittingWaste: '正在提交廢棄物追蹤...',
    wasteSubmittedSuccess: '作業完成！',
    redirecting: '重新導向中...',
    weightsExceedWarning: '輸入的重量超過初始材料',
    goBackAndCorrect: '請返回並修正數值後再提交。',
    cannotSubmit: '無法提交',
    excessAmount: '超出',
    // 主管審批
    yieldVarianceDetected: '檢測到良率差異',
    yieldReviewRequired: '需審核良率',
    yieldWithinTolerance: '產出率在容差範圍內',
    expectedYield: '預期產出率',
    actualYield: '實際產出率',
    scanSupervisorBadge: '掃描主管工牌以核准',
    scanSupervisorBadgeToComplete: '掃描主管工牌以完成工作階段',
    supervisorApproval: '需要主管核准',
    supervisorSignOff: '需要主管簽核',
    supervisorApproved: '核准者',
    supervisorOnlyCanApprove: '只有主管可以核准廢料追蹤',
    invalidBadge: '無效工牌',
    // 磅秤重量模式
    scaleWeight: '磅秤重量',
    scaleWeightFromScale: '從工站磅秤即時讀取',
    noScaleConfigured: '此工站未配置磅秤',
    scaleNotConnected: '磅秤未連接',
    waitingForStableWeight: '等待穩定重量...',
    // 工作階段摘要
    sessionSummary: '工作階段摘要',
    summaryTotalOutput: '總產出',
    totalWaste: '總廢料',
    inputWeight: '投入重量',
    outputWeight: '產出重量',
    waste: '廢料',
    returns: '退貨',
    weightDiscrepancy: '差異',
    accounted: '已計入',
    boxCount: '箱數',
    summaryPace: '速度',
    elapsedTime: '經過時間',
    summaryProgress: '進度',
    // 重量模式
    fixedWeight: '固定重量',
    catchWeight: '抓重',
    fixedWeightFromProduct: '來自產品配置',
    readyToPrint: '準備列印',
    readyToPackSubUnit: '準備包裝子單位',
  },

  // 會話詳情彈窗
  sessionDetails: {
    title: '會話詳情',
    assignment: '分配',
    details: '詳情',
    productInfo: '成品信息',
    scheduleInfo: '排程信息',
    materialInfo: '原料信息',
    materialOnHoldAlert: '材料待經理審核 — 在待審核項目被批准或拒絕之前，無法開始生產',
    existingInventory: '來自 HTE 庫存',
    inventoryTag: '(HTE)',
    allocated: '已分配',
    totalOnHold: '待審核總量',
    assignStation: '分配工作站',
    assignOperator: '分配操作員',
    splitSession: '拆分會話',
    stationAssignments: '工作站分配',
    subSessions: '子會話',
    selectStation: '選擇工作站...',
    selectOperator: '選擇操作員...',
    noStationAssigned: '未分配工作站',
    noOperatorAssigned: '未分配操作員',
    currentStation: '當前工作站',
    currentOperator: '當前操作員',
    materialWeight: '重量（磅）',
    minWeight: '最小',
    alreadyUsed: '已用',
    weightMode: '重量模式',
    fixedWeight: '固定',
    catchWeight: '抓重',
    confirmSplit: '確認拆分',
    addStation: '添加工作站',
    station: '工作站',
    operator: '操作員',
    totalWeight: '已分配總計',
    remaining: '待分配',
    weightMismatch: '總重量必須等於會話原料重量',
    minWeightWarning: '{{count}} 個子會話可能沒有足夠的重量生產 1 箱（最少 ~{{minWeight}} 磅）',
    stationAssigned: '工作站分配成功',
    // Station change modal (for active/paused)
    reassignStation: '更改工作站',
    reassignStationWarning: '員工需要在新工作站重新打卡。',
    stationChangeReason: '更改工作站原因',
    selectStationChangeReason: '選擇原因...',
    stationChangeReasons: {
      equipment_issue: '設備問題',
      workload_balance: '工作量平衡',
      operator_request: '操作員請求',
      supervisor_decision: '主管決定',
      station_maintenance: '工作站維護',
      other: '其他',
    },
    stationChangeOtherPlaceholder: '輸入原因...',
    confirmStationChange: '更改工作站',
    // Add material modal
    addMaterial: '添加原料',
    inputMode: '輸入模式',
    byWeight: '按重量',
    byBox: '按箱數',
    selectLot: '選擇原料',
    weightToAdd: '要添加的重量（磅）',
    targetBoxes: '目標箱數',
    requiredWeight: '所需重量',
    availableWeight: '可用',
    estBoxesPrefix: '預計',
    boxesUnit: '箱',
    insufficientStock: '庫存不足',
    // WCO-2607: 逐批次選擇器
    selectLotsToAdd: '選擇要新增的批次',
    perLotWeight: '重量 (磅)',
    lotCapExceeded: '不能超過批次數量',
    lotIntact: '完整',
    lotNotIntact: '非完整',
    lotByProduct: '副產品',
    lotOnHold: '暫扣',
    lotTransfer: '轉移',
    carriedToSession: '−{{cases}} 箱 / −{{weight}} 磅 已結轉至生產單 {{session}}',
    carriedToSessionPartial: '−{{weight}} 磅（部分）已結轉至生產單 {{session}}',
    carriedToSessionWeightOnly: '−{{weight}} 磅 已結轉至生產單 {{session}}',
    carriedFromSession: '+{{cases}} 箱 / +{{weight}} 磅 由生產單 {{session}} 結轉而來',
    carriedFromSessionPartial: '+{{weight}} 磅（部分）由生產單 {{session}} 結轉而來',
    carriedFromSessionWeightOnly: '+{{weight}} 磅 由生產單 {{session}} 結轉而來',
    // WCO-2659：凍結「剩餘物料」行（以重量為先，箱數為輔）。
    remainderProduced: '剩餘物料 {{weight}} 磅（{{breakdown}}）',
    remainderProducedIntact: '剩餘物料 {{weight}} 磅 / {{cases}} 箱',
    remainderProducedPartial: '剩餘物料 {{weight}} 磅（部分）',
    remainderProducedWeightOnly: '剩餘物料 {{weight}} 磅',
    remainderProducedIntactPart: '{{cases}} 箱完整',
    remainderProducedIntactWeightPart: '完整',
    remainderProducedPartialPart: '{{weight}} 部分',
    lotCases: '{{n}} 箱',
    estUsable: '預計可用 (磅)',
    noLotsAvailable: '此材料沒有可用批次',
    total: '總計',
    lotsUnit: '批次',
    casesUnit: '箱',
    estOutputBoxes: '成品箱',
    willDistribute: '將分配到現有子會話：',
    willAddToExisting: '將添加到現有子會話：',
    willCreateNew: '將創建新子會話：',
    selectTargetSubSession: '選擇目標子會話',
    selectFinishProductSubSession: '選擇子會話...',
    selectTargetSubSessions: '選擇目標子會話',
    selectNoneForNew: '取消全選以創建新子會話',
    addMaterialReason: '原因',
    selectAddMaterialReason: '選擇原因...',
    addMaterialReasons: {
      insufficient_material: '原料不足',
      production_increase: '增產',
      quality_issue: '質量問題',
      supervisor_decision: '主管決定',
      leftover_previous_session: '上次作業剩餘',
      other: '其他',
    },
    addMaterialOtherPlaceholder: '輸入原因...',
    addMaterialTabRawMaterial: '原料',
    addMaterialTabFinishProduct: '成品',
    selectProduct: '選擇成品',
    addProduct: '添加成品',
    confirmAddMaterial: '添加原料',
    // Subdivide modal
    subdivide: '細分',
    subdivideSession: '細分子會話',
    subdivideDesc: '將剩餘未處理的重量分配到新的子會話。',
    remainingWeight: '剩餘重量',
    minPerSubSession: '每子會話最小重量',
    splitWeight: '要分配的重量（磅）',
    invalidSplitWeight: '每個子會話必須有足夠的重量生產至少1箱',
    targetStation: '新子會話的工作站',
    assignLater: '稍後分配',
    subdivideReason: '原因',
    selectSubdivideReason: '選擇原因...',
    subdivideReasons: {
      workload_balance: '工作量平衡',
      speed_up_production: '加快生產',
      operator_availability: '操作員可用性',
      station_availability: '工作站可用性',
      other: '其他',
    },
    subdivideOtherPlaceholder: '輸入原因...',
    confirmSubdivide: '細分',
    subdivideSuccess: '成功將重量分配到新子會話',
    subdivideStaged: '分割已準備。點擊保存以應用。',
    cancelSubSession: '取消子會話',
    cancelSubSessionDesc: '確定要取消此子會話嗎？物料重量將退回到批次。',
    confirmCancelSubSession: '確定要取消此子會話嗎？物料重量將退回到批次。',
    subSessionCancelled: '子會話已取消',
    splitWeightTooLarge: '分割重量必須小於原始重量',
    unsavedChanges: '未保存的更改',
    unsavedChangesMessage: '您有未保存的更改。確定要關閉而不保存嗎？',
    discardChanges: '放棄更改',
    // Station conflict (priority queue) modal
    stationConflictTitle: '工作站已有活動',
    stationConflictMessage: '工作站 {station} 有一個活動的子會話 ({subSession})。',
    stationQueueExists: '已有 {count} 個子會話在排隊中。',
    stationPriorityQueue: '您的子會話將獲得優先權，排在隊列最前面。',
    stationWillActivate: '當前活動的子會話完成後，您的子會話將開始。',
    confirmQueuePriority: '優先排隊',
    priorityBadge: '優先',
    queuedWithPriority: '子會話已優先排隊',
    invalidWeight: '請輸入有效的重量',
    materialDistributed: '原料已添加並分配到現有子會話',
    newSubSessionCreated: '原料已添加為新子會話',
    materialAddedToExisting: '{{weight}} 磅將添加到現有子會話（儲存以套用）',
    materialAddedAsNew: '{{weight}} 磅將建立新子會話（儲存以套用）',
    finishProductAdded: '成品已分配到會話',
    operatorAssigned: '操作員分配成功',
    sessionSplit: '會話已成功拆分為子會話',
    sessionUpdated: '會話更新成功',
    failedToAssignStation: '分配工作站失敗',
    failedToAssignOperator: '分配操作員失敗',
    cannotClearOperator: '無法移除操作員 — 工作階段需要操作員才能運行',
    cannotClearPacker: '無法移除包裝員 — 工作階段需要包裝員才能運行',
    assignPacker: '指派包裝員',
    selectPacker: '選擇包裝員...',
    currentPacker: '目前包裝員',
    noPackerAssigned: '未指派包裝員',
    packerAssigned: '包裝員指派成功',
    failedToAssignPacker: '指派包裝員失敗',
    failedToSplitSession: '拆分會話失敗',
    cannotAddToMultiMaterial: '無法為多原料會話添加子會話',
    cannotSplitStarted: '無法拆分已開始的會話',
    startSplit: '拆分到多個工作站',
    splitDescription: '將原料重量分配到多個工作站。總計必須等於會話重量',
    splitByMaterialDescription: '為每種原料分配工作站。請為下方每種原料選擇一個工作站。',
    splitHint: '將此會話拆分到多個工作站進行並行處理',
    packing: '包裝',
    initialWeight: '初始重量',
    initialWeightTooltip: '分配給此工單的原料重量',
    unitWeight: '單位重量',
    yieldFactor: '產出率',
    estimatedOutput: '預估產出',
    carryover: '結轉',
    estimatedCases: '預估箱數',
    actualCases: '實際箱數',
    perSubSessionCases: '各子場次箱數',
    expectedCasesShort: '預估',
    actualCasesShort: '實際',
    perOutputLocationCases: '各出貨地點箱數',
    outputLocation: '地點',
    noStationYet: '尚未指派工位',
    currentProgress: '目前進度',
    cases: '箱',
    timestamps: '時間戳',
    completedAt: '完成時間',
    productionResults: '生產結果',
    actualOutput: '實際產出',
    wasteWeight: '廢料',
    notes: '備註',
    createdBy: '建立者',
    createdAt: '建立時間',
    date: '日期',
    dateCode: '日期代碼',
    brand: '品牌',
    lotNumber: '批號',
    location: '位置',
    transferBackLocation: '轉回位置',
    // 會話控制
    startSession: '開始',
    pauseSession: '暫停',
    resumeSession: '繼續',
    cancelSession: '取消',
    sessionStarted: '會話已成功開始',
    sessionPaused: '會話已成功暫停',
    sessionResumed: '會話已成功繼續',
    sessionCancelled: '會話已成功取消',
    failedToStart: '開始會話失敗',
    failedToPause: '暫停會話失敗',
    failedToResume: '繼續會話失敗',
    failedToCancel: '取消會話失敗',
    vb6TransferReminder: '請記得在VB6系統中刪除調撥單',
    vb6TransferDetails: '調撥單',
    pauseSessionDesc: '請選擇暫停此會話的原因。',
    cancelSessionDesc: '請提供取消此會話的原因。',
    cancelActiveWarning: '警告：此會話正在進行中。取消將釋放工作站，任何未保存的進度將丟失。',
    cancelReasonPlaceholder: '輸入取消原因...',
    // Cancel reason dropdown (WCO-2706)
    selectCancelReason: '選擇原因...',
    cancelReasons: {
      wrong_product: '產品錯誤',
      duplicate: '重複工單',
      entered_in_error: '輸入錯誤',
      other: '其他',
    },
    provideCancelReason: '請提供取消原因',
    sessionNotCancellable: '此會話狀態為「{{status}}」，已無法取消。僅可取消尚未開始的會話。',
    confirmPause: '確認暫停',
    confirmCancel: '確認取消',
    // History tab
    history: '歷史記錄',
    boxes: '箱',
    overrides: '覆核記錄',
    activityLog: '活動日誌',
    packedBoxes: '已包裝箱數',
    boxNumber: '箱號',
    barcode: '條碼',
    weight: '重量',
    packedAt: '包裝時間',
    updatedAt: '更新時間',
    packedBy: '包裝人員',
    updatedBy: '更新人員',
    noHistory: '未找到活動歷史記錄',
    noBoxes: '尚未包裝任何箱子',
    noCases: '尚未包裝任何箱子',
    by: '由',
    subsession: '子工作階段',
    noSubsession: '無子工作階段',
    scanIn: '掃描登入',
    scanOut: '掃描登出',
    breakStart: '開始休息',
    breakEnd: '休息結束',
    assigned: '已分配',
    unassigned: '已取消分配',
    reassigned: '重新分配',
    historyCreated: '已建立',
    historySubmitted: '已提交',
    historyReceived: '原料已接收',
    historyReady: '就緒',
    historyStarted: '已開始',
    historyCompleted: '已完成',
    historyCancelled: '已取消',
    historyPaused: '已暫停',
    historyResumed: '已恢復',
    historyReprintsResolved: '已確認補印',
    historySubdivided: '已拆分',
    historyMaterialAdded: '已新增物料',
    historyFinishProductAdded: '已新增成品',
    historyTransferReminderCreated: '已建立轉移提醒',
    historyTransferReminderResolved: '已解決轉移提醒',
    historyEdited: '已編輯',
    historyStatusChanged: '狀態已變更',
    historyStationAssigned: '已分配站點',
    historyStationUnassigned: '已取消站點',
    historyOperatorAssigned: '已分配操作員',
    historyPackerAssigned: '已分配包裝員',
    historyWeightModeChanged: '重量模式變更',
    boxPacked: '箱子已包裝',
    boxCancelled: '箱子已取消',
    box: '箱子',
    packer: '包裝員',
    override_manual_weight: '重量模式變更',
    override_label_reprint: '標籤重印',
    override_yield_signoff: '良率簽核',
    override_session_completion: '工單完成覆核',
    override_eod_signoff: '日結簽核覆寫',
    materialIssue: '原料問題',
    materialIssueDamagedWeight: '損壞重量',
    materialIssueItem: '材料',
    materialIssueLot: '批號',
    materialIssueInputWeight: '投入重量',
    materialIssueTargetOutput: '目標產出',
    materialIssueReportedBy: '報告人',
    materialIssueMethod: '方式',
    materialIssueScan: '條碼掃描',
    materialIssueManual: '手動輸入',
    // Material Added event
    materialAddedItem: '原料',
    materialAddedLot: '批號',
    materialAddedWeight: '重量',
    materialAddedReason: '原因',
    materialAddedNote: '備註',
    // Transfer Verified event
    transferVerified: '移轉已驗證',
    materialReceived: '原料已接收',
    approved: '已核准',
    received: '已接收',
    onHold: '暫停',
    rejected: '已拒絕',
    // Weight Modified event
    weightSetTo: '重量設定為',
    // Subdivided event
    splitOff: '已分出',
    remainingAfterSplit: '剩餘',
    progressAtEvent: '進度',
    boxesPackedDuringShift: '本班次包裝',
    packerSummary: '包裝員統計',
    employeeSummary: '員工統計',
    totalSessionTime: '工作階段總時間',
    timeActive: '活躍時間',
    rolePacker: '包裝員',
    roleOperator: '操作員',
    showMoreCancelled: '顯示 {{count}} 個已取消',
    hideCancelled: '隱藏已取消',
    // 提前完成（從主管面板）
    completeSession: '完成',
    sessionCompleted: '作業已完成',
    earlyCompletionWarning: '提前結束作業',
    earlyCompletionWarningDesc: '此作業尚未達到目標。將由主管覆核標記為完成。',
    wasteTrackingReminder: '注意：請確保在關閉此作業前，站點已完成廢棄物追蹤。',
    completionReason: '提前完成原因',
    selectReason: '選擇原因...',
    selectCompletionReason: '請選擇原因',
    reasonShiftEnded: '班次結束',
    reasonMaterialShortage: '材料短缺',
    reasonEquipmentIssue: '設備問題',
    reasonOther: '其他',
    confirmComplete: '完成作業',
    // Source Location
    sourceLocation: '來源位置',
    inboundTransferFrom: '入庫轉移來自',
    sourceLocationDescription: '選擇來源位置以自動建立非暫扣物料的入庫轉移。',
    selectSourceLocation: '選擇來源位置...',
    cannotEditActiveSession: '無法修改進行中/已完成的作業',
    viewTransfer: '查看轉移',
    // PDF actions
    printPdf: '列印',
    downloadPdf: '下載 PDF',
    pdfError: '無法生成 PDF',
    // Status dropdown
    statusDropdown: {
      next: '下一個（提升為就緒）',
      promoteSuccess: '子工作階段已提升為就緒',
      statusChanged: '狀態已成功更改',
      demoteToPlanned: '返回已提交',
      promoteToReady: '提升為就緒',
    },
  },
  supervisorOverride: {
    title: '主管覆核',
    labelReprints: '標籤重印',
    manualWeightMode: '手動輸入重量模式',
    endOfDaySummary: '日終摘要',
    reprintButton: '重印',
    reprinting: '重印中...',
    reprintReason: '重印原因',
    reprintSuccess: '標籤已發送至印表機',
    reprintPrintFailed: '列印失敗',
    printerUnavailable: '印表機無法連接 — 請檢查連接',
    viewBarcode: '查看條碼',
    barcodeInfo: '條碼資訊',
    noBarcodeAvailable: '無條碼資訊',
    reasons: {
      damaged: '標籤損壞',
      misprint: '印刷錯誤',
      illegible: '無法辨識',
      wrongInfo: '資訊錯誤',
      other: '其他',
    },
    selectWeightMode: '選擇重量模式',
    enableCatchWeight: '啟用隨機重量輸入',
    manualModeActive: '手動重量輸入已啟用（此面板開啟時有效）',
    manualModeDescription: '重量輸入將接受手動輸入，無需磅秤讀數。此模式在覆核面板關閉時停用。',
    activateManualMode: '啟用隨機重量',
    manualModeReason: '手動模式原因',
    manualModeRecorded: '手動重量模式覆核已記錄',
    inputWeight: '投入重量',
    outputWeight: '產出重量',
    waste: '廢料',
    yieldPercent: '良率 %',
    expectedYield: '預期良率',
    actualYield: '實際良率',
    variance: '差異',
    boxCount: '箱數',
    avgBoxWeight: '平均箱重',
    pace: '速度',
    elapsedTime: '經過時間',
    progress: '進度',
    reviewAndSignOff: '查看良率並簽核',
    signOff: '簽核',
    signOffSuccess: '良率簽核已記錄',
    signedOff: '已簽核',
    pendingSignOff: '待簽核',
    badgeInvalid: '非主管識別證',
    overrideRecorded: '覆核已成功記錄',
    noActiveSession: '無可覆核的進行中工作階段',
    selectReason: '請選擇原因',
    weightModeChanged: '重量模式已變更',
    weightModeChangeFailed: '變更重量模式失敗',
    // 作廢標籤
    voidLabel: '作廢標籤',
    confirmVoid: '作廢',
    voidSuccess: '標籤已成功作廢',
    voidFailed: '作廢標籤失敗',
  },

  // Material Issue
  materialIssue: {
    menuButton: '原料問題回報',
    title: '原料問題回報',
    description: '回報生產過程中發現的損壞原料',
    scanBarcode: '掃描箱子',
    scanBarcodeHint: '掃描損壞原料箱上的條碼',
    manualWeight: '輸入重量',
    weightLabel: '損壞重量 (磅)',
    weightPlaceholder: '輸入重量（磅）',
    reasonLabel: '退貨原因',
    reasonPlaceholder: '描述為什麼要退回此材料...',
    barcodeDetected: '已偵測到條碼',
    materialMatched: '已匹配材料',
    materialName: '材料',
    transferNumber: '轉倉編號',
    weightExtracted: '條碼中的重量',
    impactPreview: '影響預覽',
    currentInputWeight: '目前投入重量',
    newInputWeight: '新投入重量',
    currentTargetOutput: '目前目標產出',
    newTargetOutput: '新目標產出',
    currentExpectedBoxes: '目前預期箱數',
    newExpectedBoxes: '新預期箱數',
    submit: '提交原料問題',
    submitting: '提交中...',
    success: '原料問題已成功記錄',
    error: '記錄原料問題失敗',
    previousIssues: '先前的問題',
    noPreviousIssues: '此工單無先前的原料問題',
    weightExceedsAvailable: '重量超過可用材料',
    barcodeNotMatched: '條碼不匹配此工單中的任何材料',
    scanOrManual: '掃描條碼或手動輸入重量',
    lbs: '磅',
    reasonSelectPlaceholder: '選擇原因...',
    reasonWrongMaterial: '材料錯誤',
    reasonWrongTemperature: '溫度錯誤',
    reasonMaterialDamaged: '材料損壞',
    reasonMaterialExpired: '材料過期',
  },

  transferVerification: {
    title: '調撥',
    subtitle: '接收並驗證原料轉倉',
    item: '品項',
    scanBadge: '掃描主管識別證',
    viewAllTransfers: '查看所有調撥單',
    scanBadgeSubtitle: '驗證身份以開始驗收',
    pendingTransfers: '待驗收轉倉',
    noTransfersPending: '無待驗收轉倉',
    itemsPending: '項待驗收',
    startVerification: '開始驗收',
    expectedItems: '預期項目',
    scannedItems: '已掃描項目',
    expected: '預期',
    scanned: '已掃描',
    actual: '實際',
    variance: '差異',
    boxes: '箱',
    approve: '通過',
    reject: '拒絕',
    approved: '已通過',
    rejected: '已拒絕',
    approveConfirm: '確認所有項目與轉倉單一致？',
    rejectConfirm: '拒絕此項目？此操作無法復原。',
    confirmSubmit: '確認驗收',
    confirm: '確認',
    notesRequired: '請提供說明差異的備註',
    notesPlaceholder: '描述發現的情況（例如：2箱損壞、材料錯誤...）',
    notes: '備註',
    rejectReason: '拒絕原因',
    selectRejectReason: '選擇拒絕原因',
    qualityIssue: '品質問題',
    temperatureIssue: '溫度問題',
    boxNotIntact: '箱子不完整',
    wrongItem: '品項錯誤',
    wrongMaterial: '材料錯誤',
    changeItemNumber: '更正品號',
    leaveBlankIfCorrect: '品號正確則留空',
    actualQty: '實際數量',
    actualWeight: '實際重量（磅）',
    verificationComplete: '轉倉驗收完成',
    boxScanned: '已掃描箱子',
    scanBoxes: '掃描原料箱',
    scanBoxBarcode: '掃描箱子條碼（GS1-128）',
    waitingForScan: '[ ] 掃描箱子條碼',
    badgeNotBox: '已掃描識別證 — 請掃描箱子條碼',
    invalidBarcode: '條碼格式無效',
    proceedToDecision: '進入審核',
    perItemDecision: '審核項目',
    submitAll: '提交驗收',
    submitError: '提交驗收失敗',
    checkpointSaveError: '儲存掃描進度失敗 — 若您離開此頁面，進度可能會遺失',
    loadError: '載入轉倉失敗',
    boxesMatch: '箱數一致',
    boxesMismatch: '箱數不符',
    thisWeek: '本週',
    lastWeek: '上週',
    weeksAgo: '週前',
    scanTransferBarcode: '掃描轉倉條碼或輸入編號',
    enterTransferNumber: '轉倉編號...',
    transferNotFound: '找不到轉倉',
    transferLookupError: '查詢轉倉時發生錯誤',
    verifyTab: '驗收',
    historyTab: '歷史記錄',
    noHistory: '尚無驗收記錄',
    historyLoadError: '載入驗收記錄失敗',
    transfer: '轉倉',
    received: '已收',
    itemNotInTransfer: '此物品不屬於此轉倉單',
    noTransferSelected: '未選擇轉倉單',
    decidePendingFirst: '請先接受或拒絕當前箱子',
    accept: '接受',
    accepted: '已接受',
    unknownBarcode: '系統中找不到此條碼',
    badWeight: '無法從此標籤讀取有效重量。請重新掃描箱子，或使用「手動新增（標籤損壞）」。',
    invalidBoxWeight: '箱子重量無效，請重新掃描或拒收後再提交：',
    weightMissing: '未記錄重量',
    weightUnreadable: '重量無法讀取',
    notInTransfer: '不在轉倉單中',
    notInTransferWarning: '此物品不在此轉倉單中',
    itemsNotInTransfer: '不在此轉倉單中的物品',
    perItemMode: '按項目',
    wholeTransferMode: '整筆轉倉',
    itemsBreakdown: '轉移明細',
    alreadyVerified: '此轉倉單已驗收完成',
    readyToSubmit: '準備提交',
    enterActualWeight: '輸入實際重量',
    manualAdd: '手動新增（標籤損壞）',
    manualAddTitle: '手動輸入',
    selectItem: '選擇品項：',
    enterWeight: '重量（磅）',
    qty: '數量',
    manualAddReason: '手動輸入原因：',
    damagedLabel: '標籤損壞',
    missingLabel: '標籤遺失',
    labelUnreadable: '標籤無法辨識',
    manual: '手動',
    boxDetails: '箱子明細',
    hold: '暫停',
    onHold: '暫停中',
    holdReason: '暫停原因',
    selectHoldReason: '選擇暫停原因',
    holdReasonRequired: '請選擇暫停此物品的原因',
    onHoldReasons: {
      temperature: '溫度問題',
      wrongItemTomorrow: '品項錯誤（明日生產用）',
      other: '其他',
    },
    scanSummary: '掃描摘要',
    scanSummarySubtitle: '繼續前請確認掃描數量與預期數量',
    totalWeight: '總重量',
    discrepancyWarning: '偵測到差異 — 請在確認前檢查',
    confirmProceed: '確認並繼續',
    goBackToScanning: '返回',
    noDiscrepancies: '所有數量一致',
    notInTransferBoxes: '不在此轉倉單內的箱子',
    resumeTitle: '繼續上次的收貨？',
    resumeMessage: '找到 {name} 之前掃描的 {count} 箱。繼續還是重新開始？',
    resume: '繼續',
    startFresh: '重新開始',
    otherSupervisorWarning: '{name} 正在收貨此轉倉單。接手嗎？',
  },

  // Manager Approval Queue
  managerApproval: {
    title: '審批佇列',
    subtitle: '審核並批准暫停項目',
    itemsPending: '個項目待審批',
    noPendingItems: '沒有待審批項目',
    pendingApproval: '待審批',
    itemNumber: '物品編號',
    itemName: '物品名稱',
    transferNumber: '轉移單號',
    quantity: '數量',
    weight: '重量',
    holdReason: '暫停原因',
    receivedBy: '接收者',
    receivedAt: '接收時間',
    notes: '備註',
    approve: '批准',
    reject: '拒絕',
    approveConfirm: '批准此物品進行生產？',
    rejectConfirm: '拒絕此物品並退回倉庫？',
    approvalNotes: '批准備註（選填）',
    rejectionNotes: '拒絕備註（必填）',
    rejectionNotesRequired: '請提供拒絕原因',
    approved: '物品已成功批准',
    rejected: '物品已成功拒絕',
    approveError: '批准物品失敗',
    rejectError: '拒絕物品失敗',
    loadError: '載入待審批項目失敗',
  },

  // Reports
  reports: {
    title: '報表',
  },

  // End of Day Summary
  endOfDaySummary: {
    title: '每日生產總結',
    selectDate: '選擇日期',
    today: '今天',
    previousDay: '前一天',
    nextDay: '後一天',

    // Summary cards
    totalSessions: '總工單數',
    completedSessions: '已完成',
    totalBoxes: '已包裝箱數',
    voided: '已作廢',
    totalWeight: '總重量',
    waste: '廢料',
    avgYield: '平均良率',
    onTarget: '達標',
    belowTarget: '未達標',
    ofMaterial: '佔原料',

    // Tabs
    byProduct: '產品',
    byStation: '工作站',
    byWorker: '操作員',
    allSessions: '所有工單',
    wasteLog: '廢料記錄',

    // Waste table
    session: '工單',
    product: '產品',
    output: '產出',
    wastePercent: '廢料比例',
    totalWaste: '總廢料',
    noWasteLogged: '此日期無廢料記錄',
    wasteBreakdown: '按類型分類廢料',
    wasteBySession: '按工單分類廢料',

    // Table headers
    productSku: '品號',
    productItemNumber: '品號',
    productName: '產品',
    stationName: '工作站',
    location: '地點',
    workerName: '員工',
    employeeNumber: '員工編號',
    sessionsCount: '工單數',
    boxesPacked: '箱數',
    weight: '重量',
    yield: '良率',
    pace: '速度',
    paceUnit: '磅/小時',
    activeHours: '工作時數',
    status: '狀態',
    sessionNumber: '工單編號',
    operators: '操作員',
    topPerformer: '最佳表現',
    createdAt: '建立時間',
    completedAt: '完成時間',

    // Alerts
    alerts: '警示',
    noAlerts: '未發現問題',
    alertLowYield: '工單 {{session}} 良率偏低（{{pct}}%）',
    alertHighVoidRate: '工單 {{session}} 作廢率偏高（{{pct}}%）',
    alertIncompleteSessions: '{{count}} 個工單尚未完成',
    alertByproductAging: '{{item}}（{{lbs}} lbs）- 已放置 {{days}} 天',
    lowYield: '低良率',
    highVoidRate: '高作廢率',
    incompleteSessions: '未完成工單',
    viewSession: '查看',

    // Export
    export: '匯出',
    print: '列印',
    downloadCsv: '下載 CSV',
    downloadPdf: '下載 PDF',
    pdfDownloadError: '下載 PDF 失敗',

    // Material Tracking
    rawMaterial: '原料',
    materialTracking: '原料追蹤',
    initialRawMaterial: '初始原料',
    finalProduct: '成品產出',
    actualWaste: '實際廢料',
    returnsAndByProducts: '退料與副產品',
    materialUtilization: '原料利用率',
    ofInitialMaterial: '佔初始原料',
    byMaterial: '按原料分類',
    allocated: '分配',
    remainder: '剩餘',
    used: '已使用',
    noMaterialData: '此日期無原料數據',
    noMaterialLotData: '無原料批次資料',
    returns: '退料',
    byProducts: '副產品',

    // Empty states
    noData: '此日期無生產數據',
    noSessions: '未找到工單',
    errorLoading: '載入總結數據失敗',

    // Transfer Out Summary
    transferOutSummary: '出貨摘要',
    noTransferData: '此日期無出貨資料',
    expQty: '預期數量',
    actQty: '實際數量',
    expWeight: '預期重量',
    actWeight: '實際重量',
    rawMaterialsKpi: '原料',
    expected: '預期',
    received: '已收',
    totalOutput: '總產出',
    efficiency: '效率',
    onHold: '暫扣',
  },

  // Override History (Mobile)
  overrideHistory: {
    labelReprint: '標籤重印',
    manualWeight: '手動重量',
    sessionComplete: '工單完成',
    wasteRecord: '廢料記錄',
    noOverrides: '此日期無覆寫記錄',
  },

  // Warehouse Transfer Management
  warehouseTransfer: {
    title: '倉庫轉移管理',
    subtitle: '建立和管理唯豐與HTE之間的倉庫轉移',
    createTransfer: '建立轉移',
    editTransfer: '編輯轉移',
    transferDetails: '轉移詳情',
    transferList: '轉移列表',
    transferNotFound: '找不到此轉倉單',
    direction: '方向',
    wfToHte: '唯豐 → HTE',
    hteToWf: 'HTE → 唯豐',
    wfToHteShort: '唯豐 → HTE',
    hteToWfShort: 'HTE → 唯豐',
    status: '狀態',
    draft: '草稿',
    pending: '待處理',
    scanned: '已掃描',
    complete: '已完成',
    cancelled: '已取消',
    transferNumber: '轉移編號',
    transferDate: '轉移日期',
    requestDate: '申請日期',
    warehouseFrom: '發貨倉庫',
    warehouseTo: '收貨倉庫',
    locationFrom: '發貨地點',
    locationTo: '收貨地點',
    locationUpdated: '目的地地點已更新',
    locationUpdateError: '更新目的地地點失敗',
    clearCheckpointError: '清除先前掃描進度失敗 — 下次開啟轉移單時可能會出現過時的繼續提示',
    memo: '備註',
    requestBy: '申請人',
    receiveBy: '收貨人',
    createdBy: '建立人',
    completedBy: '完成人',
    completedAt: '完成時間',
    lineItems: '轉移明細',
    addItem: '新增項目',
    itemNumber: '品號',
    itemName: '品名',
    itemSearch: '尋找品項...',
    quantityRequest: '請求數量',
    quantityShipped: '出貨數量',
    weightShipped: '出貨重量',
    useSubUnit: '使用副單位',
    isFrozen: '冷凍',
    dateCode: '日期碼',
    remark: '備註',
    unit: '單位',
    brand: '品牌',
    description: '說明',
    noItems: '尚未新增項目',
    weights: '重量',
    addWeight: '新增重量',
    weight: '重量',
    weightLb: '重量 (磅)',
    pieceWeights: '單件重量',
    noWeights: '尚未記錄重量',
    submit: '提交',
    markComplete: '標記完成',
    cancelTransfer: '取消轉移',
    downloadPdf: '下載 PDF',
    print: '列印',
    printPdf: '列印 PDF',
    receiveTransfer: '接收調撥',
    receive: '接收',
    saveAsDraft: '存為草稿',
    confirmCancel: '確定要取消此轉移嗎？',
    confirmDelete: '刪除此草稿轉移？',
    deleteSuccess: '轉移已刪除',
    confirmComplete: '將此轉移標記為完成？此操作無法撤銷。',
    confirmSubmit: '提交此轉移？將從草稿變為待處理。',
    confirmDeleteItem: '從轉移中移除此項目？',
    totalTransfers: '轉移總數',
    drafts: '草稿',
    pendingTransfers: '待處理',
    pendingTransferBacks: '待處理退回轉移',
    completedTransfers: '已完成',
    lines: '項目',
    created: '建立時間',
    noTransfers: '未找到轉移',
    noTransfersDesc: '建立新的倉庫轉移以開始。',
    allDirections: '所有方向',
    dateRange: '日期範圍',
    searchPlaceholder: '按轉移編號或備註尋找...',
    pdfTitle: 'WAREHOUSE TRANSFER',
    pdfTitleCn: '存貨倉庫轉移',
    pdfPage: '頁',
    pdfDate: '日期',
    pdfRequestDate: '申請日期',
    pdfTransferNo: '轉移編號',
    pdfRequestedBy: '申請人',
    pdfReceivedBy: '收貨人',
    pdfFrom: '發貨',
    pdfTo: '收貨',
    pdfSubtotal: '小計',
    pdfSignature: '簽名',
    directionRequired: '請選擇方向',
    warehouseFromRequired: '發貨倉庫為必填',
    warehouseToRequired: '收貨倉庫為必填',
    itemRequired: '請選擇品項',
    weightPositive: '重量必須為正數',
    cannotEditNonDraft: '只能編輯草稿狀態的轉移',
    needLineItems: '轉移必須至少有一個項目',
    createSuccess: '轉移建立成功',
    updateSuccess: '轉移更新成功',
    cancelSuccess: '轉移已取消',
    completeSuccess: '轉移已標記完成',
    submitSuccess: '轉移已提交',
    itemAdded: '項目已新增至轉移',
    itemUpdated: '項目已更新',
    itemRemoved: '項目已從轉移中移除',
    weightAdded: '重量記錄已新增',
    weightRemoved: '重量記錄已移除',

    // Report tab
    transfersTab: '轉移列表',
    transfersInTab: '轉入調撥',
    transferBacksTab: '退回調撥 / 產出',
    reportTab: '報表',
    reportTitle: '轉移報表',
    reportSubtitle: '已完成轉移的明細級報表',
    dateFrom: '起始日期',
    dateTo: '結束日期',
    itemFrom: '品號起始',
    itemTo: '品號結束',
    brandFilter: '品牌',
    warehouseFromFilter: '發貨倉庫',
    warehouseToFilter: '收貨倉庫',
    searchReport: '尋找',
    exportCsv: '匯出 CSV',
    transferFrom: '轉移來源',
    qty: '數量',
    totalItems: '項目總數',
    totalQty: '數量合計',
    totalWeight: '重量合計',
    noReportData: '未找到報表資料，請調整篩選條件後重新尋找。',
    reportDateRequired: '日期範圍為必填項目。',

    // ICS Transfers tab
    icsTransfersTab: 'VB6 轉移',
    searchType: '尋找條件',
    searchByWarehouse: '倉庫編號',
    searchByTransferNo: '轉移編號',
    searchByRequestDate: '申請日期',
    searchByTransferDate: '轉移日期',
    searchByHte: 'HTE 轉移',
    searchByPending: '未完成申請',
    selectWarehouse: '選擇倉庫...',
    selectLocation: '選擇地點...',
    searchIcs: '尋找',
    allLocations: '所有位置',
    allStatuses: '全部',
    itemCodeFilter: '品項編號',
    itemCodePlaceholder: '依品項編號篩選...',
    transferNumberSearch: '轉移單號',
    transferNumberPlaceholder: '搜尋轉移單號...',
    icsTransferDetails: '轉移明細',
    itemCount: '項目數',
    noIcsResults: '未找到轉移記錄',
    enterSearchValue: '輸入尋找值',
    frozen: '冷凍',
    backToResults: '返回尋找',
    packing: '包裝',
    weightsCount: '重量',
    itemsFound: '筆資料',
    goToRecord: '到 (Go to record)',
    searchTitle: '尋找存貨倉庫轉移紀錄',
    operator: '操作員',
    dateTimeRequested: '申請日期/時間',
    totalWeightLabel: '總重量',
    from: '發貨',
    to: '收貨',
    today: '今天',
    week: '1 週',
    month: '月',
    completeCheck: '完成',
    specialRequest: '特需',
    newTransfer: '新增轉倉',
    saveAndSubmit: '儲存並提交',
    savingTransfer: '儲存中...',
    backToList: '返回列表',
    searchItemPlaceholder: '依品號或名稱尋找...',

    // Transfer detail form
    selectItemToEdit: '點擊下方項目列以查看/編輯詳情',
    additionalDetails: '附加資訊',
    avgSold: '平均銷量',
    avgBack: '平均退貨',
    qsType: 'QS 類型',
    duration: '期間',
    scanComplete: '掃描完成',
    qsPend: 'QS 待處理',
    qsRecNumber: 'QS 記錄 #',
    salespersonQs1: '業務員 QS1',
    qItem: 'Q-品項',
    findItem: '尋找...',
    searchItems: '尋找品項',
    cs: 'CS',
    pc: 'PC',
    noSearchResults: '未找到品項',
  },

  // 生產計劃
  planning: {
    title: '每週生產計劃',
    planMode: '計劃模式',
    viewMode: '檢視模式',
    addRow: '新增列',
    savePlan: '儲存計劃',
    date: '日期',
    productSku: '產品編號',
    productName: '產品名稱',
    packing: '包裝',
    cases: '箱數',
    estProductionLbs: '預估生產磅數',
    material: '原料',
    materialName: '原料名稱',
    supplierBrand: '供應商/品牌',
    location: '位置',
    fulfillment: '配料狀態',
    stockWarning: '庫存警告',
    yieldFactor: '出率',
    required: '需求量',
    available: '可用量',
    shortfall: '缺口',
    transferPending: '調撥中',
    fulfilled: '已配齊',
    partial: '部分配齊',
    unfulfilled: '未配料',
    pending: '待配料',
    notRequired: '不適用',
    noProductSelected: '請選擇產品',
    sessionCreated: '計劃排程已建立',
    sessionsFailed: '建立計劃排程失敗',
    removeRow: '移除列',
    selectProduct: '選擇產品...',
    autoResolved: '從產品配方自動解析',
    planOnlySession: '僅計劃（不配料）',
    materialFulfillment: '配料狀態',
    listView: '列表',
    calendarView: '日曆',
    oneDay: '日',
    oneWeekShort: '週',
    oneWeek: '一週',
    twoWeek: '兩週',
    month: '月',
    today: '今天',
    more: '更多',
    legend: '圖例',
    statusPending: '待處理',
    statusSubmitted: '已提交',
    statusReceived: '已收到',
    statusPlanned: '已提交', // legacy alias (WCO-2146)
    statusReady: '準備就緒',
    statusActive: '進行中',
    statusPaused: '已暫停',
    statusCompleted: '已完成',
    statusCancelled: '已取消',
    finishedProduct: '成品',
    rawMaterial: '原料',
    viewFullDetails: '查看完整詳情',
    productInfo: '產品資訊',
    materialInfo: '原料資訊',
  },

  // 每日出庫調撥
  dailyTransferOut: {
    title: '每日出庫調撥',
    finishedProducts: '成品',
    finishedProductsNotIntact: '不完整成品',
    finishedNotIntactBadge: '不完整',
    // WCO-2623: supervisor Reprint override
    reprint: '重新列印',
    reprintOverrideTooltip: '重新列印此標籤 — 取代目前的標籤',
    reprintDialogTitle: '重新列印標籤',
    reprintDialogBody: '要重新列印 {{item}} 的標籤嗎？這將取代目前的標籤 — 舊標籤將失效。',
    reprintReasonLabel: '原因',
    reprintReasonPlaceholder: '例如：標籤遺失',
    reprintConfirm: '重新列印並取代',
    reprinting: '列印中…',
    reprintSuccess: '標籤已重新列印',
    reprintFailed: '重新列印標籤失敗',
    niLabelsAlreadyPrinted: '標籤已列印',
    niLabelsPrinted: '已列印 {{count}} 張標籤',
    niLabelsPrintFailed: '列印標籤失敗',
    rejectedMaterials: '退回原料',
    remainingMaterials: '可用剩餘原料',
    remainderProducedToday: '今日剩料',
    expectedQty: '預期量',
    expectedWeight: '預期重',
    actualQty: '實際量',
    actualWeight: '實際重',
    variance: '良率差異',
    source: '來源',
    refreshActuals: '更新實際值',
    finalizeTransferOut: '完成出庫調撥',
    submitTransfer: '提交調撥',
    confirmSubmit: '這將建立ICS調撥文件並使其對倉庫可見。是否繼續？',
    submitSuccess: '調撥提交成功',
    submitFailed: '提交調撥失敗',
    outputDestinations: '出貨目的地',
    destination: '目的地',
    expectedCases: '預計',
    actualCases: '實際',
    casesVariance: '差異',
    tombstoned: '已取消',
    unscannedBoxesWarning: '箱尚未掃描至目的地 — 請在提交前掃描',
    allBoxesScanned: '所有生產的箱已掃描至目的地',
    outputLabel: '產出',
    transferLabel: '轉移',
    noTransferForDay: '當日尚無轉移單據。',
    transferNotSubmittedYet: '此轉移單尚未提交 — 先掃描箱數，再提交以生成單據。',
    selectTransfer: '轉移：',
    noOutputForDay: '當日尚無生產產出。',
    outputNoRecordYet: '此產出尚無生產記錄 — 產出送出時才會生成。',
    selectOutput: '產出：',
    newTransferBack: '新增退回',
    newLabel: '新增',
    typeLabel: '類型',
    selectDestination: '選擇目的地',
    create: '建立',
    transferCreated: '已建立轉移',
    outputCreated: '已建立產出',
    createFailed: '建立失敗',
    rawMaterialTransfer: '轉移',
    newRawMaterialTransfer: '新增原料退回',
    noRawMaterialsToTransfer: '沒有可退回的原料',
    createTransfer: '建立轉移',
    rawTransferCreated: '已建立原料退回',
    rawTransferFailed: '建立原料退回失敗',
    incompleteSessionsWarning: '無法完成 — 部分生產工單尚未完成',
    status: '狀態',
    type: '類型',
    prePopulated: '預填',
    actualsWithinTolerance: '在容差範圍內',
    varianceWarning: '差異警告',
    finalized: '已出貨',
    notShipped: '未出貨',
    complete: '已完成',
    noDataForDate: '此日期無出庫調撥資料',
    confirmFinalize: '確定要完成此每日出庫調撥嗎？',
    finalizeSuccess: '每日出庫調撥已成功完成',
    pdfDownloadFailed: '下載調撥 PDF 失敗',
    downloadTransferPdf: '下載調撥 PDF',
    finalizeFailed: '完成每日出庫調撥失敗',
    refreshSuccess: '實際值已更新',
    refreshFailed: '更新實際值失敗',
    noItemsToRefresh: '無項目可更新 — 請先完成一個工作階段',
    autoGenerated: '自動產生',
    manual: '手動',
    dailyOut: '退回調撥',
    sourceFilter: '來源篩選',
    linkedSessions: '關聯排程',
    itemNumber: '品號',
    itemName: '品項名稱',
    category: '類別',
    notes: '備註',
    expectedYF: '預期良率',
    actualYF: '實際良率',
    estimate: '預估',
    completed: '已完成',
    rejected: '退回',
    remainder: '剩餘',
    byProduct: '副產品',
    byProducts: '副產品',
    byProductMarketable: '可銷售',
    byProductProduction: '用於生產',
    packing: '包裝',
    tabSummary: '生產摘要',
    tabTransferDetail: '調撥明細',
    tabOutputDetail: '產出明細',
    transfer: '調撥',
    excludeFailed: '更新排除狀態失敗',
    reserve: '保留',
    casesRow: '整箱',
    bufferRow: '緩衝',
  },

  // Box Search
  boxSearch: {
    title: '箱子查詢',
    subtitle: '搜尋和篩選成品箱',
    filters: '篩選條件',
    item: '品項',
    selectItem: '選擇品項...',
    allItems: '所有品項',
    dateCode: '日期碼',
    dateCodePlaceholder: '例如：26037',
    packedFrom: '包裝起始時間',
    packedTo: '包裝結束時間',
    location: '位置',
    selectLocation: '選擇位置...',
    allLocations: '所有位置',
    includeVoided: '包含已作廢',
    search: '搜尋',
    exportExcel: '匯出 Excel',
    print: '列印',
    summary: '摘要',
    totalBoxes: '總箱數',
    totalWeight: '總重量',
    boxNumber: '箱號',
    itemNumber: '品號',
    productName: '產品名稱',
    weight: '重量',
    packedAt: '包裝時間',
    operator: '操作員',
    packer: '包裝員',
    packedBy: '包裝人員',
    status: '狀態',
    session: '生產批次',
    station: '工作站',
    noResults: '找不到符合條件的箱子',
    lbs: '磅',
    barcode: '條碼',
    clearFilters: '清除',
  },

  // Yield Variance Report
  yieldVariance: {
    title: '良率差異報告',
    description: '與預期良率差異±1%以上的工單',
    fetchError: '無法載入良率差異資料',
    totalVariances: '總差異數',
    overYield: '超標',
    underYield: '低於標準',
    avgVariance: '平均差異',
    startDate: '開始日期',
    endDate: '結束日期',
    product: '產品',
    operator: '操作員',
    station: '工作站',
    varianceType: '差異類型',
    allVariances: '所有差異',
    overYieldOnly: '僅超標',
    underYieldOnly: '僅低於標準',
    session: '工單',
    date: '日期',
    expectedYield: '預期良率',
    actualYield: '實際良率',
    variance: '差異',
    lfExpected: '預期 LF',
    lfActual: '實際 LF',
    lfVariance: 'LF 差異',
    needsReview: '需審查',
    anomalyTooltip: '實際勞動係數偏離標準 ±20%',
    observedThroughput: '產能 (磅/工時)',
    productiveTime: '生產時間',
    workers: '工人數',
    throughputCalc: {
      title: '產能 (磅/工時) — 計算方式',
      output: '產出',
      productiveTime: '生產時間',
      hrs: '小時',
      workers: '工人數',
      step1: '步驟 1 — 每人產率 = 產出 ÷ 小時 ÷ 工人數',
      perWorkerHour: '磅/每人工時',
      step2: '步驟 2 — × 標準人數 (2)',
      why: '÷工人數得出真實的每人產率；×2 將其換算為標準 2 人班組基準，使達標班組無論人數多少，勞動係數皆約為 1.0。',
      notMeasurable: '無法計算 — 此次生產缺少產出、工人數或生產時間。',
      roundingNote: '顯示的數值已四捨五入；結果以完整精度計算，因此用顯示的兩位小數手動相乘可能相差約 0.01。',
    },
    approvedBy: '批准人',
    noData: '未找到符合篩選條件的良率差異',
    weightDetails: '重量詳情',
    throughputLabour: '產能與勞動',
    inputWeight: '投入重量',
    targetWeight: '目標重量',
    outputWeight: '產出重量',
    carryover: '結轉',
    rawMaterial: '原料',
    wasteBreakdown: '廢料明細',
    noWasteData: '無廢料記錄',
    approvalDetails: '批准詳情',
    approvedAt: '批准時間',
    reason: '原因',
    overrideNoDetails: '覆核完成（無批准詳情）',
    noApprovalRequired: '無需批准',
    suggestionsTitle: '重複良率差異',
    suggestionsDescription: '項原料有重複良率差異 — 請檢視建議的良率因子更新',
    suggestionsLoading: '正在檢查重複差異...',
    suggestionsError: '無法載入建議',
    finishedProduct: '成品',
    currentYield: '目前良率',
    suggestedYield: '建議良率',
    occurrences: '發生次數',
    lastOccurrence: '最近一次',
    recentHistory: '近期差異記錄',
    yieldSource: '來源',
    hideSuggestions: '隱藏',
    showSuggestions: '檢視',
    wasteTypes: {
      byProduct: '副產品',
      byProductMarketable: '副產品 (可銷售)',
      byProductProduction: '副產品 (用於生產)',
      disposable: '可棄廢料',
      waterLiquid: '水分/液體損失',
      humanError: '人為錯誤',
      remainderIntact: '剩餘 (完整)',
      remainderNotIntact: '剩餘 - 非完整',
      finishProductNotIntact: '成品 - 非完整',
    },
  },

  // Work Schedule
  workSchedule: {
    title: '工作排程',
    weeklySchedule: '每週工作排程',
    employee: '員工',
    operators: '操作員',
    packers: '包裝員',
    stations: '工作站',
    activeStations: '啟用的工作站',
    off: '休息',
    cutRole: '操作員 (CUT)',
    packRole: '包裝員 (PACK)',
    stationActive: '工作站啟用',
    copyToNextWeek: '複製到下週',
    unsavedChanges: '您有未儲存的變更',
    loadError: '載入排程失敗',
    saveSuccess: '排程儲存成功',
    saveError: '儲存排程失敗',
    copySuccess: '已複製 {{count}} 個指派到下週',
    copyError: '複製排程失敗',
    summary: '摘要',
  },

  // Approval History Report
  approvalHistory: {
    title: '審批歷史',
    subtitle: '管理人員對暫停庫存項目的審批和拒絕記錄',
    dateRange: '日期範圍',
    dateFrom: '從',
    dateTo: '到',
    actionFilter: '操作',
    searchPlaceholder: '按項目編號或名稱搜索...',
    date: '日期',
    itemNumber: '項目 #',
    itemName: '項目名稱',
    transferNumber: '轉移 #',
    quantity: '數量',
    weight: '重量',
    holdReason: '暫停原因',
    action: '操作',
    manager: '經理',
    receivedBy: '接收人',
    receivedAt: '接收日期',
    notes: '備註',
    approved: '已批准',
    rejected: '已拒絕',
    all: '全部',
    noRecords: '未找到審批歷史',
    noRecordsDesc: '沒有符合篩選條件的審批或拒絕記錄。',
    holdReasons: {
      temperature: '溫度',
      damaged: '損壞',
      wrong_quantity: '數量錯誤',
      quality: '品質',
      expiration: '過期',
      other: '其他',
    },
  },

  // Item Summary Report
  itemSummaryReport: {
    title: '項目摘要報告',
    rawMaterials: '原材料',
    finishedProducts: '成品',
    itemNumber: '項目編號',
    itemName: '名稱',
    brand: '品牌',
    location: '位置',
    yieldFactor: '良率',
    laborFactor: '人工係數',
    lastUsed: '最後使用',
    lastProduced: '最後生產',
    materials: '材料',
    search: '按項目編號或名稱搜尋...',
    allBrands: '所有品牌',
    allLocations: '所有位置',
    startDate: '開始日期',
    endDate: '結束日期',
    noData: '未找到項目',
    noDataHint: '嘗試調整過濾條件',
    laborPlaceholder: '即將推出',
    source: '來源',
    expandMaterials: '顯示材料',
    collapseMaterials: '隱藏材料',
    page: '頁',
    of: '共',
    showing: '顯示',
    items: '項目',
  },

  // Clock In Modal (from Daily Queue row click)
  clockInModal: {
    title: '打卡進入工作階段',
    subSessionInfo: '子工作階段資訊',
    scanBadge: '掃描員工識別證',
    scanBadgeHint: '掃描識別證或手動輸入員工編號',
    enterManually: '或手動輸入：',
    badgePlaceholder: '員工編號...',
    lookingUp: '正在查詢員工...',
    selectRole: '選擇角色',
    operator: '操作員',
    packer: '包裝員',
    clockIn: '打卡',
    clockingIn: '正在打卡...',
    currentAssignments: '目前分配',
    notAssigned: '未分配',
    since: '自',
    noStation: '此子工作階段未分配工作站',
    sessionNotActive: '此工作階段無法接受打卡（狀態：{status}）',
    employeeFound: '已找到員工',
    relieveConfirm: '替換 {name}？',
    relieveDescription: '{name} 目前擔任 {role}。他們將被登出。',
    yesRelieve: '是的，替換並打卡',
    alreadyHere: '已在此工作階段打卡',
    transferConfirm: '從 {station} 轉移？',
    transferDescription: '目前在 {station} 以 {role} 身份打卡中。要轉移到這裡嗎？',
    yesTransfer: '是的，轉移',
    alreadyHerePrompt: '您想要做什麼？',
    scanOut: '掃描登出',
    takeBreak: '休息',
    scanOutSuccess: '已成功登出',
    breakStarted: '休息開始',
    currentlyAs: '目前以此身份掃描中',
    onBreak: '休息中',
    success: '掃描成功',
    error: '打卡失敗',
    errorSessionPlanned: '工作階段尚未就緒 — 請先指派操作員和包裝員',
    errorSessionCompleted: '此工作階段已完成',
    errorSessionCancelled: '此工作階段已取消',
    errorNoActiveSession: '此工作站沒有進行中的工作階段',
    materialsNotReceived: '子工作階段 {subSessionNumber} 的原物料尚未接收。生產無法開始。',
    awaitingAssignment: '子工作階段 {subSessionNumber} 的轉移已接收，但子工作階段正在等待操作員/包裝員指派。',
    scheduledFuture: '子工作階段 {subSessionNumber} 排定於未來日期，目前無法開始。',
  },

  // 副產品對應原物料
  byproductMapping: {
    title: '副產品對應',
    subtitle: '將副產品項目連結至其來源原物料',
    selectRawMaterial: '選擇原物料',
    searchRawMaterials: '搜尋原物料...',
    linkedByproducts: '已連結的副產品',
    noByproductsLinked: '尚未連結任何副產品',
    addByproduct: '新增副產品',
    removeByproduct: '移除副產品',
    confirmRemove: '確認移除？',
    mappingCreated: '副產品連結成功',
    mappingDeleted: '副產品已取消連結',
    searchItems: '搜尋項目...',
    notes: '備註',
    noResults: '找不到結果',
    alreadyLinked: '所有符合的項目已經連結',
    existingLinkages: '現有連結',
    byproductCount: '{{count}} 個副產品',
    noMappingsYet: '尚未建立任何連結',
    productMappingTitle: '產品對應',
    byproductTab: '副產品對應',
    inputOutputTab: '投入 / 產出對應',
    packingMaterialTab: '包裝材料對應',
    comingSoon: '即將推出',
    comingSoonDescription: '此功能正在開發中，即將推出。',
    inputOutputDescription: '定義每個成品使用哪些原物料。此對應將用於生產計劃和物料需求規劃。',
    packingMaterialDescription: '將包裝材料（箱、袋、標籤）連結至其相關產品。此對應將用於包裝需求和庫存規劃。',
  },

  // 投入 / 產出對應
  inputOutputMapping: {
    subtitle: '查看每個 HTE 成品使用哪些原物料（來自 ICS）',
    selectProduct: '選擇產品',
    searchProducts: '搜尋產品...',
    noResults: '找不到結果',
    selectProductPrompt: '從清單中選擇一個產品以查看其原物料',
    rawMaterials: '原物料',
    noRawMaterials: '此產品無原物料資料',
    itemNumber: '品號',
    name: '名稱',
    yieldFactor: '產出率',
    laborFactor: '人力',
    batchSize: '批量',
    teamSize: '組員數',
    comments: '備註',
    addRawMaterial: '新增原物料',
    searchRawMaterials: '搜尋原物料...',
    preference: '優先順序 #',
    alreadyLinked: '已連結',
    mappingCreated: '原物料連結成功',
  },

  // 人力係數管理（標準值模型，WCO-2474）
  labourFactor: {
    tabTitle: '人力係數',
    subtitle: '為產品的每項原物料設定標準產出量（2 人一組每小時磅數，已含成品率）。人力係數會自動推算。',
    selectProduct: '選擇產品',
    searchProducts: '搜尋產品...',
    selectProductPrompt: '從清單中選擇一個產品以設定其人力係數',
    noResults: '找不到結果',
    materials: '原物料',
    noMaterials: '此產品無原物料資料',
    itemNumber: '品號',
    name: '名稱',
    throughput: '磅/時 (2人組)',
    allowance: '寬放 %',
    labourFactor: '人力係數',
    baseline: '基準',
    noBaselineHint: '尚未選擇基準——請選擇一項原物料作為基準以推算人力係數。',
    baselineNeedsThroughput: '設為基準前，請先輸入此原物料的磅/時。',
    invalidThroughput: '請輸入正數，或清空欄位以取消設定。',
    saved: '產能已儲存',
    allowanceSaved: '寬放已儲存',
    invalidAllowance: '請輸入 0 至 100 之間的百分比。',
    baselineSet: '基準已更新',
    saveFailed: '儲存失敗',
    history: '變更紀錄',
    historyTitle: '變更紀錄',
    historyEmpty: '尚無變更紀錄',
    historyLoading: '載入中…',
    historyThroughput: '磅/時',
    historyBaselineSet: '設為基準',
    historyBaselineUnset: '取消基準',
    close: '關閉',
  },

  // 包裝材料對應
  packingMaterialMapping: {
    title: '包裝材料對應',
    subtitle: '將包裝材料（箱、標籤、袋）連結至 HTE 成品',
    defaultAllProducts: '預設（所有產品）',
    selectProduct: '選擇產品',
    searchProducts: '搜尋產品...',
    linkedPackingMaterials: '已連結的包裝材料',
    noPackingMaterialsLinked: '尚未連結任何包裝材料',
    addPackingMaterial: '新增包裝材料',
    removePackingMaterial: '移除包裝材料',
    confirmRemove: '確認移除？',
    mappingCreated: '包裝材料連結成功',
    mappingDeleted: '包裝材料已取消連結',
    searchItems: '搜尋包裝材料...',
    notes: '備註',
    noResults: '找不到結果',
    alreadyLinked: '所有符合的項目已經連結',
    existingLinkages: '現有連結',
    packingMaterialCount: '{{count}} 個包裝材料',
    noMappingsYet: '尚未建立任何連結',
    level_case: '每箱',
    level_subunit: '每小包',
    packingMaterials: '包裝材料',
    qtyNeeded: '需要',
    qtyToTransfer: '調撥',
    available: '可用',
    stockSufficient: '庫存充足',
    stockInsufficient: '庫存不足',
  },

  // 使用者管理（主管管理操作員）
  userManagement: {
    title: '使用者管理',
    subtitle: '管理操作員帳號',
    addOperator: '新增操作員',
    selectEmployee: '選擇員工',
    searchEmployees: '搜尋員工...',
    searchOperators: '搜尋操作員...',
    noEmployeesAvailable: '沒有可新增的員工',
    noOperators: '找不到操作員',
    userAdded: '操作員新增成功',
    userUpdated: '使用者更新成功',
    generatedPassword: '密碼',
    userDeleted: '操作員已成功刪除',
    employeeNumber: '員工編號',
    username: '使用者名稱',
    fullName: '全名',
    lastModified: '最後修改',
    createdAt: '建立時間',
    name: '姓名',
    email: '電子郵件',
    active: '啟用',
    inactive: '停用',
    activate: '啟用',
    deactivate: '停用',
    confirmDelete: '刪除使用者',
    deleteWarning: '確定要刪除 {{name}} 嗎？此操作無法復原。',
    defaultPasswordNote: '預設密碼為員工編號。操作員應在首次登入時更改密碼。',
    userId: '使用者ID',
    userIdPlaceholder: '輸入使用者ID...',
    userIdTooShort: '使用者ID至少需要3個字元',
    userIdTaken: '使用者ID已被使用',
    passwordFromUserId: '預設密碼為使用者ID + 隨機4位數字。操作員應在首次登入時更改密碼。',
    userDetails: '使用者詳情',
    editUser: '編輯使用者',
    password: '密碼',
    showPassword: '顯示密碼',
    hidePassword: '隱藏密碼',
    enterNewPassword: '輸入新密碼...',
    enterNewPasswordHint: '輸入新密碼並點擊編輯按鈕儲存。',
    confirmPasswordChange: '變更密碼',
    confirmPasswordChangeMessage: '確定要變更此使用者的密碼嗎？',
    newPassword: '新密碼',
    passwordSaved: '密碼儲存成功',
    passwordEncrypted: '密碼已加密',
  },

  icsUserManagement: {
    title: 'ICS 使用者存取',
    subtitle: '啟用 ICS 員工存取生產系統',
    searchPlaceholder: '依名稱、使用者ID或員工編號搜尋...',
    noResults: '未找到使用者',
    userId: '使用者ID',
    name: '名稱',
    employeeNum: '員工編號',
    icsRole: 'ICS 角色',
    prodRole: '生產角色',
    active: '啟用中',
    disabled: '已停用',
    notEnabled: '未啟用',
    icsDisabled: 'ICS 已停用',
    pendingPassword: '待設定密碼',
    enable: '啟用',
    disable: '停用',
    reEnable: '重新啟用',
    enableUser: '啟用使用者',
    userCreated: '使用者帳戶已建立',
    userEnabled: '使用者已成功啟用',
    statusUpdated: '狀態已更新',
    assignRole: '指派生產角色',
    tempPassword: '臨時密碼',
    tempPasswordInfo: '請將此臨時密碼分享給使用者。他們在首次登入時需要設定新密碼。',
    tempPasswordNote: '此密碼僅顯示一次。請務必記下或分享給使用者。',
    addUser: '新增使用者',
    allEnabled: '所有 ICS 員工已全部啟用',
    deleteUser: '刪除使用者',
    deleteWarning: '確定要永久刪除 {{name}} 的生產帳戶嗎？這將移除其登入憑證，且無法復原。',
    userDeleted: '使用者帳戶已刪除',
    changeRole: '點擊更改角色',
    roleUpdated: '角色更新成功',
    resetPassword: '重設密碼',
    resetPasswordConfirm: '這將把密碼重設為臨時密碼。使用者需要在下次登入時更改密碼。',
    passwordResetDone: '密碼重設完成',
    passwordReset: '密碼重設成功',
    lastModified: '最後修改',
  },

  changePassword: {
    title: '設定您的密碼',
    subtitle: '您必須在繼續之前設定新密碼。',
    newPassword: '新密碼',
    newPasswordPlaceholder: '輸入您的新密碼',
    confirmPassword: '確認密碼',
    confirmPasswordPlaceholder: '再次輸入密碼',
    requirements: '密碼要求：',
    minLength: '至少 8 個字元',
    uppercase: '至少一個大寫字母',
    lowercase: '至少一個小寫字母',
    digit: '至少一個數字',
    special: '至少一個特殊字元 (!@#$%^&*)',
    passwordsMatch: '密碼相符',
    submit: '設定密碼',
    success: '密碼設定成功。請重新登入。',
  },

  // 相機條碼掃描器
  cameraScanner: {
    title: '掃描條碼',
    instruction: '將相機對準條碼',
    permissionDenied: '相機權限被拒絕。請在瀏覽器設定中允許相機存取。',
    noCamera: '此裝置未找到相機。',
    error: '無法啟動相機。',
    openCamera: '使用相機',
  },

  // 出貨掃描記錄
  productionOutputScan: {
    title: '掃描生產產出',
    selectOutput: '選擇產出',
    scanCases: '掃描箱',
    selectPrompt: '選擇一筆轉移',
    outputRow: '產出',
    transferRow: '轉移',
    cases: '箱',
    noRows: '當日沒有產出或轉移',
    switch: '切換',
    scanPrompt: '掃描一箱...',
    noScans: '尚無掃描',
    extrasHint: 'FP-NI／副產品（額外，不計入預期箱數）',
    fpniTag: 'FP-NI',
    byproductTag: '副產品',
    send: '送出',
    sent: '已送出',
    sentBadge: '已送出',
    sentHint: '已送往倉庫',
    confirmStep: '確認',
    confirmPrompt: '送出前請檢查每個產出與轉移，全部都必須完整掃描。',
    allSentComplete: '本日所有產出與轉移皆已送出 — 沒有需要掃描的項目。',
    complete: '完成',
    incomplete: '未完成',
    reviewConfirm: '確認',
    reviewStep: '檢視',
    backToScan: '返回',
    confirmSend: '確認並送出',
    sendAllReady: '送出所有已完成',
    noneReady: '尚無目的地完成掃描',
    confirmSendAll: '送出 {{count}} 個已完成的容器？',
    incompleteBlocked: '並非所有產出／轉移都已完整掃描',
    confirmComingSoon: '檢查完成－送出步驟將於下一階段連接',
    confirmPopupBody: '這會寫入生產、銷售與倉庫轉移記錄，並將全部送到倉庫。是否繼續？',
    delete: '刪除',
    deleted: '已刪除',
    confirmDelete: '刪除此草稿？其編號將被重複使用。',
    // WCO-2412: 各生產場次對帳（分組掃描檢視 + 目標提示）
    plannedSurplus: '計劃 {{planned}}，多出 +{{delta}}',
    plannedDeficit: '計劃 {{planned}}，短少 −{{delta}}',
    extrasGroup: '額外（FP-NI／副產品）',
    targetBreakdown: '實際明細',
    targetTotal: '實際合計',
    colPlan: '預期',
    colTarget: '實際',
  },

  shipOutScan: {
    title: '掃描調撥項目',
    scanTransfer: '掃描調撥單條碼',
    enterTransferNumber: '輸入或掃描調撥單號...',
    orSelectTransfer: '或選擇待處理的調撥單',
    scanBadge: '掃描您的識別證',
    enterBadge: '掃描您的員工識別證...',
    scanBoxes: '掃描箱子',
    scanBoxBarcode: '掃描箱子條碼...',
    totalScanned: '已掃描總數',
    duplicateBox: '此箱子已在此調撥單中掃描過',
    boxScanned: '箱子已掃描',
    scanFailed: '無法記錄掃描',
    // WCO-2465 — 針對性掃描錯誤訊息（對應後端錯誤碼）
    errWrongTargetOutput_finished: '這是成品箱 — 請掃描到生產產出，而非原料轉倉。',
    errWrongTargetOutput_byproduct: '這是副產品箱 — 請掃描到生產產出，而非原料轉倉。',
    errWrongTargetOutput_fpni: '這是 FP-NI 品項 — 請掃描到生產產出，而非原料轉倉。',
    errWrongTargetOutput: '此品項屬於生產產出 — 請掃描到該處，而非原料轉倉。',
    errWrongTargetTransfer: '這是原料標籤 — 請掃描到其倉庫轉倉，而非生產產出。',
    errWrongDay: '此材料屬於另一天的轉倉（{{otherDate}}），不是這一筆。',
    errUnrecognized: '無法辨識的條碼 — 與此次掃描無任何相符項目。',
    // WCO-2545 —手動新增損壞箱子（標籤無法掃描）
    addDamagedCase: '新增損壞箱子（無條碼）',
    damagedCasesAvailable: '損壞箱子（點擊新增）',
    addToTransfer: '加入調撥單',
    manualDamagedItem: '品項',
    manualDamagedItemPlaceholder: '選擇品項…',
    manualDamagedWeight: '重量',
    manualDamagedItemRequired: '請選擇損壞箱子的品項',
    manualDamagedWeightRequired: '請輸入損壞箱子的重量',
    manualDamagedAdded: '損壞箱子已加入調撥單',
    undoScan: '撤銷',
    transferNotFound: '找不到調撥單',
    invalidBadge: '無效的識別證',
    employeeNotFound: '找不到員工',
    scanRemoved: '掃描已移除',
    clearAll: '清除全部',
    clearAllConfirm: '確定要清除此調撥單的所有掃描紀錄嗎？',
    clearAllSuccess: '所有掃描紀錄已清除',
    noScansYet: '尚未掃描任何箱子',
    loadingTransfer: '載入調撥單中...',
    scannedBy: '掃描人',
    step: '步驟',
    barcodeNotFound: '在生產庫存中找不到此條碼',
    itemNotInTransfer: '此品項不在此調撥單中',
    sessionsNotCompleted: '生產工作必須完成後才能掃描',
    confirmScan: '確認掃描',
    scanConfirmed: '出貨掃描已確認',
    remainingMaterial: '剩餘原料',
    loggedFromWaste: '已從廢料追蹤記錄',
    summaryTitle: '預期 vs 已掃描',
    item: '品項',
    expectedQty: '預期數量',
    scannedQty: '已掃描',
    expectedWt: '預期重量',
    scannedWt: '掃描重量',
    remainingIntact: '剩餘材料 (完整)',
    remainingNotIntact: '剩餘材料 (不完整)',
    unusedLot: '未使用批次',
    confirmOnPalette: '確認已在棧板上',
    manualConfirm: '手動確認',
    byProduct: '副產品',
    byProductMarketable: '副產品 (可銷售)',
    byProductProduction: '副產品 (生產用)',
    rejectedMaterial: '退回材料',
  },

  // 開發工具
  devTools: {
    title: '開發工具',
    resetHteData: '重置 HTE 資料',
    resetDescription: '刪除邊緣和雲端資料庫上所有 HTE 生成的資料。生產表完全清除。ICS 記錄 (>= 900001) 已移除。序列重置。此操作無法復原。',
    resetConfirmTitle: '確認重置 HTE 資料',
    resetConfirmWarning: '這將永久刪除邊緣的所有 HTE 生產資料，以及邊緣和雲端資料庫上 HTE 生成的 ICS 記錄 (>= 900001)。序列將重置為 900001。',
    typeToConfirm: '輸入 RESET 以確認',
    resetButton: '重置所有資料',
    resetting: '重置中...',
    resetSuccess: 'HTE 資料重置成功',
    resetPartial: 'HTE 資料重置完成但有錯誤',
    resetError: 'HTE 資料重置失敗',
    resetSummary: '各資料表刪除行數：',
    rowsDeleted: '行',
    sequencesReset: '序列已重置',
    stationsReset: '工作站已重置為閒置',
    dangerZone: '危險操作區',
    dangerZoneDescription: '僅用於開發和測試的不可逆操作。',
    edgeLocal: '邊緣本地資料庫',
    stagingVm: '雲端資料庫',
    gcpProd: 'GCP Prod (10.142.0.5)',
    oracle: 'Oracle',
    noRecords: '未找到 HTE 記錄',
    targetLabel: '目標資料庫：',
    cloudDbTarget: '雲端資料庫目標：',
    targetAll: '全部（邊緣 + 雲端）',
    targetEdge: '僅邊緣',
    targetCloud: '全部雲端（GCP + 暫存 VM + Oracle）',
    targetGcpProd: '僅 GCP Prod',
    targetStagingVm: '雲端（dev/staging）',
    targetOracle: '僅 Oracle',
  },

  // 操作員效率
  operatorEfficiency: {
    sortBy: '排序方式',
    yield: '產率',
    speed: '速度',
    both: '綜合',
    noHistory: '無歷史記錄',
    avgYield: '平均產率',
    avgSpeed: '平均速度',
    lbsPerHour: '磅/小時',
    sessions: '場次',
    rank: '排名',
  },
  sync: {
    cloudOffline: '雲端離線',
    synced: '雲端已同步',
    pending: '待同步',
    issues: '個同步問題',
    syncing: '正在同步...',
    lastPull: '上次拉取',
    neverPulled: '尚未拉取',
    failed: '失敗',
    pullFailed: '拉取失敗',
    pullStale: '拉取過期',
  },
  offline: {
    youAreOffline: '目前離線 — 操作將保存在本機',
    backOnline: '已恢復連線',
    pendingActions: '個待同步操作',
    syncing: '正在同步...',
    allSynced: '所有操作已同步',
    offlineLabel: '離線',
  },

  // Tutorial / Walkthrough
  tutorial: {
    skip: '跳過導覽',
    pageTitle: '教學',
    pageSubtitle: '透過逐步指南學習如何使用生產系統。',
    replayTour: '重新導覽',
    completed: '培訓已完成',
    tourInfo: '互動導覽共有 {{count}} 個步驟，將引導您了解您角色的主要功能。',

    sections: {
      dailyQueue: '每日佇列',
      dailyQueueDesc: '查看今天分配給您的生產工單。每張卡片顯示產品、工位和目標產量。',
      weeklySchedule: '週排程',
      weeklyScheduleDesc: '一覽整週排程。提前計劃，了解即將到來的工單。',
      production: '生產',
      productionDesc: '打卡進入工位、啟動生產工單、掃描箱子、追蹤廢料並完成工單。',
      supervisorDashboard: '主管面板',
      supervisorDashboardDesc: '監控所有活動工位，查看即時進度，從一個畫面管理生產。',
      productionPlanning: '生產計劃',
      productionPlanningDesc: '建立和排程生產工單。分配產品、工位、操作員和目標重量。',
      schedule: '排程',
      scheduleDesc: '以日或週格式查看所有工位的完整生產排程。',
      transfers: '倉庫調撥',
      transfersDesc: '管理倉庫調撥 — 掃描箱子進出冷藏庫並追蹤調撥狀態。',
      inventory: '庫存',
      inventoryDesc: '查看批次追蹤、成品、箱子查詢和包裝材料。',
      reports: '報表',
      reportsDesc: '查閱每日總結、產率差異報表和覆寫歷史記錄。',
      productionRecords: '生產記錄',
      productionRecordsDesc: '搜尋和查看歷史生產工單資料。',
      managerDashboard: '經理面板',
      managerDashboardDesc: '審核待處理的審批、調撥請求和生產狀態。',
      adminDashboard: '管理員面板',
      adminDashboardDesc: '系統活動概覽、使用者統計和關鍵指標。',
      userManagement: '使用者管理',
      userManagementDesc: '查看和管理所有使用者帳戶。分配角色和監控登入活動。',
      stationManagement: '工位管理',
      stationManagementDesc: '建立、編輯和設定生產工位。設定允許的材料和位置。',
      settings: '設定',
      settingsDesc: '設定系統偏好、管理 ICS 使用者帳戶和查看系統資訊。',
    },

    operator: {
      dailyQueue: { title: '每日佇列', content: '這是您的每日工作佇列。您將看到今天分配給您的所有工單。' },
      sessionCard: { title: '工單卡片', content: '每張卡片是一個生產工單。點擊查看產品、工位和目標重量等詳情。' },
      sessionCardScanIn: { title: '打卡視窗', content: '點擊工單卡片時會開啟此視窗。您可以查看工單詳情、目前分配，並掃描工牌或輸入員工編號來打卡。' },
      weeklyView: { title: '週排程', content: '切換到這裡查看您的整週排程。' },
      clockIn: { title: '掃描登入', content: '掃描工位 QR 碼或選擇您的工位來掃描登入並開始工作。' },
      scanBadge: { title: '掃描工牌', content: '掃描工位後，您會看到工單資訊。現在掃描您的員工工牌來打卡登入。' },
      scanSuccess: { title: '已登入！', content: '您已成功登入，將被導向生產畫面。可以開始工作了！' },
      sessionInfo: { title: '工單資訊', content: '此列顯示您目前的工單詳情 — 產品、原料、批號、包裝規格和預期箱數。' },
      startSession: { title: '開始工單', content: '分配到工單後，點擊開始來啟動生產。' },
      boxScanning: { title: '箱子掃描', content: '在此輸入或秤量每個箱子。當重量在目標範圍內時會變綠色，即可列印標籤。' },
      printLabel: { title: '列印標籤', content: '當重量有效時，點擊列印標籤為箱子列印條碼標籤。標籤包含產品、批號、重量和日期碼。' },
      badgeLabelScan: { title: '工牌和標籤掃描', content: '列印後，掃描您的工牌再掃描箱子上的標籤以確認已貼上。這確保每個箱子都正確標記。' },
      finishSession: { title: '完成工單', content: '當您已包裝所有目標箱數時，會出現目標達成畫面。點擊完成工單以繼續廢料記錄。' },
      wasteTracking: { title: '廢料記錄', content: '逐步記錄所有廢料和副產品 — 不可回收廢料、人為錯誤、副產品和剩餘物。主管將在最後審核簽署。' },
      completeSession: { title: '完成工單', content: '完成後點擊完成。您將記錄廢料和副產品，如果產率超出範圍，主管可能需要審批。' },
    },

    supervisor: {
      dashboard: { title: '主管面板', content: '這是您的面板。一覽所有活動工位及其當前狀態。' },
      stationCards: { title: '工位卡片', content: '每張卡片顯示工位的當前工單、操作員和生產進度。' },
      productionPlanning: { title: '生產計劃', content: '在此建立新的生產工單。分配產品、工位、操作員和目標重量。' },
      sessionList: { title: '工單列表', content: '查看所有已提交、進行中和已完成的工單。根據需要重新排序佇列。' },
      schedule: { title: '排程', content: '查看所有工位的完整生產排程。' },
      transfers: { title: '倉庫調撥', content: '管理倉庫調撥 — 掃描箱子進出冷藏庫。' },
      inventory: { title: '庫存', content: '查看批次追蹤、成品和包裝材料。' },
      reports: { title: '報表', content: '從此頁面存取所有生產報表。' },
      reportEod: { title: '每日總結報表', content: '查看每日生產摘要 — 產量、產率和操作員績效。' },
      reportYield: { title: '產率差異', content: '標記為需要產率審查的工單顯示在這裡。根據需要審批或調查。' },
      productionRecords: { title: '生產記錄', content: '搜尋和查看歷史生產資料。' },
      settings: { title: '設定', content: '設定您的偏好和系統設定。' },
    },

    manager: {
      dashboard: { title: '經理面板', content: '您的審批佇列和生產概覽。待處理項目顯示在這裡。' },
      approvalCards: { title: '審批佇列', content: '審核並批准或拒絕調撥請求和其他經理級操作。' },
      productionPlanning: { title: '生產計劃', content: '查看和建立生產工單，與主管相同的存取權限。' },
      schedule: { title: '排程', content: '所有工位和日期的完整生產排程。' },
      transfers: { title: '倉庫調撥', content: '管理倉庫調撥和冷藏庫移動。' },
      inventory: { title: '庫存', content: '追蹤批次、成品和材料消耗。' },
      reports: { title: '報表', content: '存取生產報表 — 每日總結、產率差異和覆寫記錄。' },
      productionRecords: { title: '生產記錄', content: '搜尋過去的生產工單和績效資料。' },
    },

    admin: {
      dashboard: { title: '管理員面板', content: '系統概覽，包含使用者統計和關鍵指標。' },
      users: { title: '使用者管理', content: '查看和管理系統中的所有使用者帳戶。' },
      inventory: { title: '庫存', content: '完整的庫存管理 — 批次、成品和材料。' },
      stations: { title: '工位管理', content: '建立、編輯和設定生產工位。' },
      schedule: { title: '排程', content: '查看所有工位的生產排程。' },
      settings: { title: '設定', content: '設定系統偏好和管理 ICS 使用者帳戶。' },
      icsUsers: { title: 'ICS 使用者管理', content: '啟用 ICS 員工為生產系統使用者。設定角色和臨時密碼。' },
    },
  },
  // Manager Guide (step-by-step workflow)
  managerGuide: {
    title: '生產指南',
    next: '下一步',
    previous: '上一步',
    steps: {
      plan: '計劃',
      transfers: '轉移',
      production: '生產',
      review: '檢視',
    },
    plan: {
      sessionsToday: '今日工單',
      sessionsOnDate: '{{date}} 工單',
      planned: '已提交',
      active: '進行中',
      completed: '已完成',
      operators: '操作員',
      packers: '包裝員',
      stations: '工作站',
      scheduledToday: '今日排程',
      scheduledOnDate: '{{date}} 排程',
      todaysSessions: '今日工單',
      sessionsForDate: '{{date}} 工單',
      createSession: '建立工單',
      viewAll: '查看全部',
      noSessions: '今日尚無計劃工單',
      createFirst: '建立你的第一個工單',
      sessionCreated: '工單建立成功',
      cancelled: '已取消',
    },
    transfers: {
      title: '轉移',
      thisWeek: '本週',
      pending: '待處理',
      scanned: '已掃描',
      completed: '已完成',
      recentTransfers: '近期轉移',
      last7Days: '最近7天',
      viewAll: '查看所有轉移',
      noTransfers: '最近7天沒有轉移',
      transferNo: '轉移編號',
      date: '日期',
      from: '來源',
      to: '目的地',
      items: '項目',
      status: '狀態',
      lastEdited: '最後編輯',
      showVb6: '顯示 VB6 轉移',
    },
    produce: {
      activeStations: '活動工作站',
      boxesPacked: '已包裝箱數',
      expectedOutput: '預期產出',
      actualOutput: '實際產出',
      totalWeight: '總重量',
      waitingToStart: '等待開始',
      openStations: '開啟工作站',
      allStarted: '所有工單已開始',
      promoteFailed: '開啟工作站失敗',
      liveProgress: '即時進度',
      fullView: '完整檢視',
      noActive: '目前沒有進行中的工單',
    },
    review: {
      totalOutput: '總產出',
      of: '的',
      expected: '預期',
      completion: '完成率',
      sessionsCompleted: '已完成工單',
      pendingApprovals: '待審核',
      approvalsTitle: '待審核項目',
      quickLinks: '快速連結',
      endOfDay: '日結摘要',
      endOfDayDesc: '查看每日生產報告',
      records: '生產紀錄',
      recordsDesc: '瀏覽歷史紀錄',
      transfers: '轉移',
      transfersDesc: '查看與管理轉移',
      productionSummary: '生產摘要',
      materialFlow: '物料流向',
      input: '投入',
      output: '產出',
      waste: '廢料',
      returns: '退回與副產品',
      utilization: '利用率',
      byProduct: '按產品',
      product: '產品',
      sessions: '工單',
      boxes: '箱數',
      weight: '重量',
      yield: '良率',
      wasteBreakdown: '廢料明細',
      wasteType: '類型',
      alerts: '警報',
      noData: '今日無生產數據',
      viewFullReport: '查看完整報告',
      complete: '完成',
    },
  },

  // 副產品批次新鮮度指標
  freshness: {
    fresh: '新鮮',
    useSoon: '即將過期',
    oldStock: '舊庫存',
    alertByProductAging: '副產品需要在生產中使用',
    resolveForToday: '今日已處理',
  },
  // WCO-2618: per-row (i) print-audit popover on the Print Labels sections.
  printAudit: {
    title: '標籤列印記錄',
    empty: '尚未列印標籤。',
    printedColumn: '已列印',
    printed: '已列印',
    notPrinted: '未列印',
    by: '列印者',
    statusActive: '有效',
    statusSuperseded: '已取代',
    statusVoided: '已作廢',
  },
} as const;
